{
  "about.blocks": "Siū 管制 ê 服侍器",
  "about.contact": "聯絡方法：",
  "about.default_locale": "預設",
  "about.disclaimer": "Mastodon是自由、開放原始碼ê軟體，mā是Mastodon gGmbH ê商標。",
  "about.domain_blocks.no_reason_available": "原因bē-tàng用",
  "about.domain_blocks.preamble": "Mastodon一般ē允准lí看別ê fediverse 服侍器來ê聯絡人kap hām用者交流。Tsiah ê 是本服侍器建立ê例外。",
  "about.domain_blocks.silenced.explanation": "Lí一般buē-tàng tuì tsit ê服侍器看用戶ê紹介kap內容，除非lí明白tshiau-tshuē á是跟tuè伊。",
  "about.domain_blocks.silenced.title": "有限制",
  "about.domain_blocks.suspended.explanation": "Uì tsit ê服侍器來ê資料lóng bē處理、儲存á是交換，無可能kap tsit ê服侍器ê用者互動á是溝通。.",
  "about.domain_blocks.suspended.title": "權限中止",
  "about.language_label": "言語",
  "about.not_available": "Tsit ê資訊bē-tàng tī tsit ê服侍器使用。",
  "about.powered_by": "由 {mastodon} 提供ê非中心化社群媒體",
  "about.rules": "服侍器ê規則",
  "account.account_note_header": "個人ê註解",
  "account.activity": "活動",
  "account.add_note": "加私人ê註解",
  "account.add_or_remove_from_list": "加添kàu列單á是uì列單thâi掉",
  "account.badges.admin": "管理員",
  "account.badges.blocked": "封鎖ê",
  "account.badges.bot": "機器lâng",
  "account.badges.domain_blocked": "封鎖ê域名",
  "account.badges.group": "群組",
  "account.badges.muted": "消音ê",
  "account.badges.muted_until": "直到 {until} 消音",
  "account.block": "封鎖 @{name}",
  "account.block_domain": "封鎖域名 {domain}",
  "account.block_short": "封鎖",
  "account.blocked": "Hőng封鎖",
  "account.cancel_follow_request": "取消跟tuè",
  "account.copy": "Khóo-pih個人資料ê連結",
  "account.direct": "私人提起 @{name}",
  "account.disable_notifications": "停止佇 {name} PO文ê時通知我",
  "account.edit_note": "編私人ê註解",
  "account.edit_profile": "編輯個人資料",
  "account.edit_profile_short": "編輯",
  "account.enable_notifications": "佇 {name} PO文ê時通知我",
  "account.endorse": "用個人資料推薦對方",
  "account.familiar_followers_many": "Hōo {name1}、{name2}，kap {othersCount, plural, other {其他 lí熟似ê # ê lâng}} 跟tuè",
  "account.familiar_followers_one": "Hōo {name1} 跟tuè",
  "account.familiar_followers_two": "Hōo {name1} kap {name2} 跟tuè",
  "account.featured": "精選ê",
  "account.featured.accounts": "個人資料",
  "account.featured.collections": "收藏",
  "account.featured.new_collection": "新ê收藏",
  "account.field_overflow": "展示規篇內容",
  "account.filters.all": "逐ē活動",
  "account.filters.boosts_toggle": "顯示轉PO",
  "account.filters.posts_boosts": "PO文kap轉PO",
  "account.filters.posts_only": "PO文",
  "account.filters.posts_replies": "PO文kap回應",
  "account.filters.replies_toggle": "顯示回應",
  "account.follow": "跟tuè",
  "account.follow_back": "Tuè tńg去",
  "account.follow_back_short": "Tuè tńg去",
  "account.follow_request": "請求跟tuè lí",
  "account.follow_request_cancel": "取消跟tuè",
  "account.follow_request_cancel_short": "取消",
  "account.follow_request_short": "請求",
  "account.followers": "跟tuè伊ê",
  "account.followers.empty": "Tsit ê用者iáu bô lâng跟tuè。",
  "account.followers_counter": "Hōo {count, plural, other {{count} ê lâng}}跟tuè",
  "account.followers_you_know_counter": "Lí所知影ê {counter} ê lâng",
  "account.following": "伊跟tuè ê",
  "account.following_counter": "Teh跟tuè {count,plural,other {{count} ê lâng}}",
  "account.follows.empty": "Tsit ê用者iáu buē跟tuè別lâng。",
  "account.follows_you": "跟tuè lí",
  "account.go_to_profile": "行kàu個人資料",
  "account.hide_reblogs": "Tshàng tuì @{name} 來ê轉PO",
  "account.in_memoriam": "佇tsia追悼。",
  "account.join_modal.day": "Kang",
  "account.join_modal.me": "Lí加入 {server} 佇",
  "account.join_modal.me_anniversary": "加入聯邦宇宙周年快樂！Lí加入 {server} 佇",
  "account.join_modal.me_today": "Che是lí加入 {server} ê頭一kang！",
  "account.join_modal.other": "{name} 加入 {server} 佇",
  "account.join_modal.other_today": "Che是 {name} 加入 {server} ê頭一kang！",
  "account.join_modal.share.celebrate": "分享慶祝ê PO文",
  "account.join_modal.share.intro": "分享介紹ê PO文",
  "account.join_modal.share.welcome": "分享歡迎ê PO文",
  "account.join_modal.years": "{number, plural, other {年}}",
  "account.joined_short": "加入ê時",
  "account.languages": "變更訂閱的語言",
  "account.last_active": "頂kái活動ê時間",
  "account.link_verified_on": "Tsit ê連結ê所有權佇 {date} 受檢查",
  "account.locked_info": "Tsit ê口座ê隱私狀態鎖起來ah。所有者ē手動審查thang kā跟tuè ê lâng。",
  "account.media": "媒體",
  "account.mention": "提起 @{name}",
  "account.menu.add_to_list": "加入去列單……",
  "account.menu.block": "封鎖口座",
  "account.menu.block_domain": "封鎖 {domain}",
  "account.menu.copied": "Khóo-pih口座ê連結kàu剪貼簿á",
  "account.menu.copy": "Khóo-pih連結",
  "account.menu.direct": "私人ê提起",
  "account.menu.hide_reblogs": "佇時間線內tshàng轉送",
  "account.menu.mention": "提起",
  "account.menu.mute": "消音口座",
  "account.menu.note.description": "Kan-ta lí ē當看",
  "account.menu.open_original_page": "佇 {domain} 看",
  "account.menu.remove_follower": "Suá掉跟tuè ê",
  "account.menu.report": "檢舉口座",
  "account.menu.share": "分享……",
  "account.menu.show_reblogs": "佇時間線內底顯示轉送",
  "account.menu.unblock": "取消封鎖口座",
  "account.menu.unblock_domain": "取消封鎖 {domain}",
  "account.menu.unmute": "取消kā口座消音",
  "account.moved_to": "{name} 指示tsit-má伊ê新口座是：",
  "account.mute": "消音 @{name}",
  "account.mute_notifications_short": "Kā通知消音",
  "account.mute_short": "消音",
  "account.muted": "消音ah",
  "account.mutual": "Lín sio跟tuè",
  "account.name.copy": "Khóo-pih口座ê名",
  "account.name.help.domain": "",
  "account.name.help.domain_self": "{domain} 是管理lí ê個人資料hām PO文ê服侍器。",
  "account.name.help.footer": "就像lí通寄電子phue予用無kâng電子批服務者ê儂kâng款，lí ē當hām佇無kâng Mastodon服侍器ê，kap佇其他聯邦宇宙ê lâng互動。",
  "account.name.help.header": "@handle 親像電子批地址",
  "account.name.help.username": "{username} 是tsit ê口座佇in ê服侍器ê用者名。佇別ê服侍器可能有kâng名ê別lâng。",
  "account.name.help.username_self": "{username} 是lí ê口座佇tsit ê服侍器ê用者名。佇別ê服侍器可能有kâng名ê別lâng。",
  "account.name_info": "Tse是siánn？",
  "account.no_bio": "Bô提供敘述。",
  "account.node_modal.callout": "私人ê筆記kan-ta lí 通看。",
  "account.node_modal.edit_title": "編私人ê註解",
  "account.node_modal.error_unknown": "Bē當儲存tsit ê註解",
  "account.node_modal.field_label": "私人ê註解",
  "account.node_modal.save": "儲存",
  "account.node_modal.title": "加私人ê註解",
  "account.note.edit_button": "編輯",
  "account.note.title": "私人ê筆記（kan-ta lí ē當看）",
  "account.open_original_page": "開原來ê頁",
  "account.pending": "Teh審核",
  "account.posts": "PO文",
  "account.remove_from_followers": "Kā {name} tuì跟tuè lí ê ê內底suá掉",
  "account.report": "檢舉 @{name}",
  "account.requested_follow": "{name} 請求跟tuè lí",
  "account.share": "分享 @{name} ê個人資料",
  "account.show_reblogs": "顯示uì @{name} 來ê轉PO",
  "account.statuses_counter": "{count, plural, other {{count} ê PO文}}",
  "account.timeline.pinned": "釘起來ê",
  "account.timeline.pinned.view_all": "看逐ê釘起來ê PO文",
  "account.unblock": "取消封鎖 @{name}",
  "account.unblock_domain": "Kā域名 {domain} 取消封鎖",
  "account.unblock_domain_short": "取消封鎖",
  "account.unblock_short": "取消封鎖",
  "account.unendorse": "Mài tī個人資料推薦伊",
  "account.unfollow": "取消跟tuè",
  "account.unmute": "取消消音 @{name}",
  "account.unmute_notifications_short": "Kā通知取消消音",
  "account.unmute_short": "取消消音",
  "account_edit.advanced_settings.bot_hint": "Kā別lâng講tsit ê口座主要行自動操作，可能無lâng監控",
  "account_edit.advanced_settings.bot_label": "機器lâng ê口座",
  "account_edit.advanced_settings.title": "進一步ê設定",
  "account_edit.bio.add_label": "加添個人紹介",
  "account_edit.bio.edit_label": "編個人紹介",
  "account_edit.bio.placeholder": "加一段短紹介，幫tsān別lâng認捌lí。",
  "account_edit.bio.title": "個人紹介",
  "account_edit.bio_modal.add_title": "加添個人紹介",
  "account_edit.bio_modal.edit_title": "編個人紹介",
  "account_edit.column_button": "做好ah",
  "account_edit.column_title": "編輯個人資料",
  "account_edit.custom_fields.add_label": "加框á",
  "account_edit.custom_fields.edit_label": "編框á",
  "account_edit.custom_fields.placeholder": "加lí ê代名詞、外部連結，á是其他lí beh分享ê。",
  "account_edit.custom_fields.reorder_button": "重排框á",
  "account_edit.custom_fields.tip_content": "Lí通用驗證連kàu lí 所有ê網站ê連結，來增加lí ê Mastodon口座ê通信ê程度。",
  "account_edit.custom_fields.tip_title": "撇步：加驗證過ê連結",
  "account_edit.custom_fields.title": "自訂欄",
  "account_edit.custom_fields.verified_hint": "我beh án-tsuánn加驗證過ê連結？",
  "account_edit.display_name.add_label": "加添顯示ê名",
  "account_edit.display_name.edit_label": "編顯示ê名",
  "account_edit.display_name.placeholder": "Lí ê顯示ê名是lí ê名佇lí ê個人資料kap時間線出現ê方式。",
  "account_edit.display_name.title": "顯示ê名",
  "account_edit.featured_hashtags.edit_label": "加hashtag",
  "account_edit.featured_hashtags.placeholder": "幫tsān別lâng認捌，kap緊緊接近使用lí收藏ê主題。",
  "account_edit.featured_hashtags.title": "特色ê hashtag",
  "account_edit.field_actions.delete": "Thâi掉框á",
  "account_edit.field_actions.edit": "編框á",
  "account_edit.field_delete_modal.confirm": "Lí敢確定beh thâi掉tsit ê自訂ê框á？Tsit ê動作bē當改倒轉。",
  "account_edit.field_delete_modal.delete_button": "Thâi掉",
  "account_edit.field_delete_modal.title": "敢beh thâi掉自訂ê框á？",
  "account_edit.field_edit_modal.add_title": "加自訂ê框á",
  "account_edit.field_edit_modal.discard_confirm": "棄sak",
  "account_edit.field_edit_modal.discard_message": "Lí有iáu bē儲存ê改變。Lí kám確定想欲棄sak in？",
  "account_edit.field_edit_modal.edit_title": "編自訂ê框á",
  "account_edit.field_edit_modal.length_warning": "建議ê字數限制超過ah。行動設備ê用者可能bē當讀著kui个框á ê內容。",
  "account_edit.field_edit_modal.link_emoji_warning": "Gún無建議佇URL內底用自訂ê emoji。為著避免用者舞花去，自訂ê框á若包含自訂emoji kap URL，kan-ta ē顯示做文字。",
  "account_edit.field_edit_modal.name_hint": "例：「個人網站」",
  "account_edit.field_edit_modal.name_label": "標簽",
  "account_edit.field_edit_modal.url_warning": "若beh加連結，請佇起頭包含 {protocol}。",
  "account_edit.field_edit_modal.value_hint": "例：「https://example.me」",
  "account_edit.field_edit_modal.value_label": "值",
  "account_edit.field_reorder_modal.drag_cancel": "Giú ê動作取消ah。框á「{item}」予lâng khǹg ah。",
  "account_edit.field_reorder_modal.drag_end": "框á「{item}」予lâng khǹg ah。",
  "account_edit.field_reorder_modal.drag_instructions": "Beh重整理自訂ê框á，請tshi̍h空白khí或者是Enter。Teh suá振動ê時，請用方向khí來kā框á suá kah頂懸á是下底。請koh tshi̍h空白khí或者是Enter來kā框á khǹg佇新ê位置，á是tshi̍h ESC khí取消。",
  "account_edit.field_reorder_modal.drag_move": "框á「{item}」suá振動ah。",
  "account_edit.field_reorder_modal.drag_over": "框á「{item}」已經suá kah「{over}」面頂。",
  "account_edit.field_reorder_modal.drag_start": "有揀框á「{item}」。",
  "account_edit.field_reorder_modal.handle_label": "Giú框á「{item}」",
  "account_edit.field_reorder_modal.title": "重整理框á",
  "account_edit.image_alt_modal.add_title": "加添說明文字",
  "account_edit.image_alt_modal.details_content": "著愛：<ul> <li>照圖描述家kī</li> <li>用第三人稱（比如用「阿明」，毋是「我」）</li> <li>束結，幾个詞就夠ah</li> </ul> 毋通：<ul> <li>用「……ê相片」結束，這對讀螢幕程式是加講ê</li> </ul> 例：<ul> <li>「阿明穿青ê siá-tsuh，koh掛眼鏡」</li> </ul>",
  "account_edit.image_alt_modal.details_title": "撇步：個人資料ê相片 ê 說明文字",
  "account_edit.image_alt_modal.edit_title": "編說明文字",
  "account_edit.image_alt_modal.text_hint": "ALT說明文字通幫tsān讀螢幕程式ê用者知影lí ê內容。",
  "account_edit.image_alt_modal.text_label": "替代文字",
  "account_edit.image_delete_modal.confirm": "Lí敢確定beh thâi掉tsit幅圖？Tsit ê動作bē當改倒轉。",
  "account_edit.image_delete_modal.delete_button": "Thâi掉",
  "account_edit.image_delete_modal.title": "Kám beh thâi掉影像？",
  "account_edit.image_edit.add_button": "加圖片",
  "account_edit.image_edit.alt_add_button": "加添說明文字",
  "account_edit.image_edit.alt_edit_button": "編說明文字",
  "account_edit.image_edit.remove_button": "Suá掉圖片",
  "account_edit.image_edit.replace_button": "取代圖片",
  "account_edit.item_list.delete": "Thâi {name}",
  "account_edit.item_list.edit": "編 {name}",
  "account_edit.name_modal.add_title": "加添顯示ê名",
  "account_edit.name_modal.edit_title": "編顯示ê名",
  "account_edit.profile_tab.button_label": "自訂",
  "account_edit.profile_tab.hint.description": "Tsiah ê設定自訂用官方應用程式佇 {server} 所看著ê內容，毋kú in可能無用佇別ê服侍器或者用第三方應用程式ê用者。",
  "account_edit.profile_tab.hint.title": "展示結果uân-á可能無kâng款",
  "account_edit.profile_tab.show_featured.description": "「特色ê」是通揀ê分頁，其中lí ē當展示別ê口座。",
  "account_edit.profile_tab.show_featured.title": "顯示「特色ê」分頁",
  "account_edit.profile_tab.show_media.description": "「媒體」是通揀ê分頁，展示lí包含影像kap影片ê PO文。",
  "account_edit.profile_tab.show_media.title": "展示「媒體」分頁",
  "account_edit.profile_tab.show_media_replies.description": "若是啟用，媒體分頁展示lí ê PO文kap對別lâng ê PO文ê回應。",
  "account_edit.profile_tab.show_media_replies.title": "佇媒體分頁內包含回應",
  "account_edit.profile_tab.show_relations.description": "佇lí ê個人資料內底，展示lí跟tuè ê口座kap跟tuè lí ê予別lâng看。Lâng iáu是ē當看見lí敢有跟tuè伊。",
  "account_edit.profile_tab.show_relations.title": "展示「跟tuè伊ê」kap「伊跟tuè ê」",
  "account_edit.profile_tab.subtitle": "自訂lí ê個人檔案顯示ê方法。",
  "account_edit.profile_tab.title": "個人資料顯示設定",
  "account_edit.save": "儲存",
  "account_edit.upload_modal.back": "轉去",
  "account_edit.upload_modal.done": "做好ah",
  "account_edit.upload_modal.next": "後一步",
  "account_edit.upload_modal.step_crop.zoom": "伸kiu",
  "account_edit.upload_modal.step_upload.button": "瀏覽檔案",
  "account_edit.upload_modal.step_upload.dragging": "Giú kàu tsia傳上去",
  "account_edit.upload_modal.step_upload.header": "揀圖片",
  "account_edit.upload_modal.step_upload.hint": "WEBP、PNG、GIF á是 JPG 格式，上大 {limit}MB。{br}圖會伸kiu kàu {width}x{height} px。",
  "account_edit.upload_modal.title_add.avatar": "加個人資料ê相",
  "account_edit.upload_modal.title_add.header": "加封面ê相片",
  "account_edit.upload_modal.title_replace.avatar": "替換個人資料ê相",
  "account_edit.upload_modal.title_replace.header": "替換封面ê相片",
  "account_edit.verified_modal.details": "用驗證連kàu個人網站ê連結來加添lí ê Mastodon個人檔案ê通信ê程度。下kha是運作ê方法：",
  "account_edit.verified_modal.invisible_link.details": "加連結kàu lí ê網頁頭(header)。上重要ê部份是 rel=\"me\"，伊防止通過用者生成ê網站內容來做假包。Lí甚至佇網頁ê header毋免用 {tag}，反轉用link標簽，但是HTML定著佇無執行JavaScript ê時陣，就ē當接近使用。",
  "account_edit.verified_modal.invisible_link.summary": "Án-tsuánn khàm掉tsit ê連結？",
  "account_edit.verified_modal.step1.header": "Khóo-pih 下kha ê HTML程式碼，貼佇lí ê網站ê網頁頭(header)底",
  "account_edit.verified_modal.step2.details": "Lí若有加lí ê網站成做自訂ê框á，lí需要thâi掉，koh加tse來啟動驗證。",
  "account_edit.verified_modal.step2.header": "Kā lí ê網站加做自訂ê框á",
  "account_edit.verified_modal.title": "Án-tsuánn加驗證過ê連結",
  "account_edit_tags.add_tag": "加 #{tagName}",
  "account_edit_tags.column_title": "編標簽",
  "account_edit_tags.help_text": "特色ê hashtag幫tsān用者發現kap hām lí ê個人資料互動。In會成做過濾器，佇lí ê個人資料頁ê活動內底出現。",
  "account_edit_tags.max_tags_reached": "Lí已經加kàu特色ê hashtag數ê盡磅ah。",
  "account_edit_tags.search_placeholder": "編輯hashtag……",
  "account_edit_tags.suggestions": "建議：",
  "account_edit_tags.tag_status_count": "{count, plural, other {# 篇PO文}}",
  "account_list.hidden_notice": "Tse kan-ta lí ē當看。若beh kā tsit ê列單予別lâng看，請kàu <link>{page} > {modal} > {field}</link>。",
  "account_list.total": "{total, plural, other {# ê口座}}",
  "account_note.placeholder": "Tshi̍h tse加註kha",
  "admin.dashboard.daily_retention": "註冊以後ê用者維持率（用kang計算）",
  "admin.dashboard.monthly_retention": "註冊以後ê用者維持率",
  "admin.dashboard.retention.average": "平均",
  "admin.dashboard.retention.cohort": "註冊ê月",
  "admin.dashboard.retention.cohort_size": "新用者",
  "admin.impact_report.instance_accounts": "個人資料ē hőng thâi掉ê用者數",
  "admin.impact_report.instance_followers": "本站ê跟tuè者ē流失ê數",
  "admin.impact_report.instance_follows": "In ê跟tuè者ē流失ê數",
  "admin.impact_report.title": "影響ê摘要",
  "alert.rate_limited.message": "請tī {retry_time, time, medium} 以後koh試。",
  "alert.rate_limited.title": "限速ah",
  "alert.unexpected.message": "發生意外ê錯誤。.",
  "alert.unexpected.title": "Ai-ioh!",
  "alt_text_badge.title": "替代文字",
  "alt_text_modal.add_alt_text": "加添說明文字",
  "alt_text_modal.add_text_from_image": "Tuì圖加說明文字",
  "alt_text_modal.cancel": "取消",
  "alt_text_modal.change_thumbnail": "改縮小圖",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "請替聽有困難ê敘述tsit ê內容…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "請替看有困難ê敘述tsit ê內容…",
  "alt_text_modal.done": "做好ah",
  "announcement.announcement": "公告",
  "annual_report.announcement.action_build": "建立我ê Wrapstodon",
  "annual_report.announcement.action_dismiss": "毋免，多謝。",
  "annual_report.announcement.action_view": "看我ê Wrapstodon",
  "annual_report.announcement.description": "發現其他關係lí佇最近tsi̍t年參與Mastodon ê狀況。",
  "annual_report.announcement.title": "Wrapstodon {year} 已經kàu ah",
  "annual_report.nav_item.badge": "新ê",
  "annual_report.shared_page.donate": "寄付",
  "annual_report.shared_page.footer": "由 Mastodon 團隊用 {heart} 產生",
  "annual_report.shared_page.footer_server_info": "{username} 用 {domain}，pháng Mastodon ê社里之一。",
  "annual_report.summary.archetype.booster.desc_public": "{name} 不斷走tshuē通轉送 ê PO文，靠完美ê對千，放大其他ê創作者。",
  "annual_report.summary.archetype.booster.desc_self": " Lí不斷走tshuē通轉送 ê PO文，靠完美ê對千，放大其他ê創作者。",
  "annual_report.summary.archetype.booster.name": "射手",
  "annual_report.summary.archetype.die_drei_fragezeichen": "？？？",
  "annual_report.summary.archetype.lurker.desc_public": "Guán知 {name} 捌佇某物所在，用伊恬靜ê方法享受Mastodon。",
  "annual_report.summary.archetype.lurker.desc_self": "Guán知lí捌佇某物所在，用li恬靜ê方法享受Mastodon。",
  "annual_report.summary.archetype.lurker.name": "Stoic主義者",
  "annual_report.summary.archetype.oracle.desc_public": "{name} 發表ê新ê PO文較tsē回應，保持 Mastodon tshinn-tshioh kap面對未來。",
  "annual_report.summary.archetype.oracle.desc_self": "Lí發表ê新ê PO文較tsē回應，保持 Mastodon tshinn-tshioh kap面對未來。",
  "annual_report.summary.archetype.oracle.name": "先知",
  "annual_report.summary.archetype.pollster.desc_public": "{name} 建立投票較tsē其他PO文類型，佇Mastodon培養好奇。",
  "annual_report.summary.archetype.pollster.desc_self": "Lí建立投票較tsē其他PO文類型，佇Mastodon培養好奇。",
  "annual_report.summary.archetype.pollster.name": "思考者",
  "annual_report.summary.archetype.replier.desc_public": "{name} 定定應別lâng ê PO文，用新ê討論kā Mastodon授粉。",
  "annual_report.summary.archetype.replier.desc_self": "You 定定應別lâng ê PO文，用新ê討論kā Mastodon授粉。",
  "annual_report.summary.archetype.replier.name": "Ia̍h仔",
  "annual_report.summary.archetype.reveal": "顯露我ê原形",
  "annual_report.summary.archetype.reveal_description": "感謝lí成做Mastodon ê一部份！Tsit-má tshuē出lí佇 {year} 年表現ê原形。",
  "annual_report.summary.archetype.title_public": "{name} ê原形",
  "annual_report.summary.archetype.title_self": "Lí ê原形",
  "annual_report.summary.close": "關",
  "annual_report.summary.copy_link": "Khóo-pih連結",
  "annual_report.summary.followers.new_followers": "{count, plural, other {新ê跟tuè ê}}",
  "annual_report.summary.highlighted_post.boost_count": "Tsit篇PO文予lâng轉送 {count, plural, other {# kái}}。",
  "annual_report.summary.highlighted_post.favourite_count": "Tsit篇PO文予lâng收藏 {count, plural, other {# kái}}。",
  "annual_report.summary.highlighted_post.reply_count": "Tsit篇PO文得著 {count, plural,  other {# 篇回應}}。",
  "annual_report.summary.highlighted_post.title": "上hang ê PO文",
  "annual_report.summary.most_used_app.most_used_app": "上tsē lâng用ê app",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "上tsia̍p用ê hashtag",
  "annual_report.summary.most_used_hashtag.used_count": "Lí佇{count, plural, other { # 篇PO文}}內包含tsit ê hashtag。",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} 佇{count, plural, other { # 篇PO文}}內包含tsit ê hashtag。",
  "annual_report.summary.new_posts.new_posts": "新ê PO文",
  "annual_report.summary.percentile.text": "<topLabel>Tse 予lí變做 {domain} ê用戶ê </topLabel><percentage></percentage><bottomLabel></bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Gún bē kā Bernie講。",
  "annual_report.summary.share_elsewhere": "分享kàu別位",
  "annual_report.summary.share_message": "我得著 {archetype} ê典型！",
  "annual_report.summary.share_on_mastodon": "佇Mastodon分享",
  "attachments_list.unprocessed": "（Iáu bē處理）",
  "audio.hide": "Tshàng聲音",
  "block_modal.no_collections": "Lín雙方lóng bē當kā對方加入收藏。若是通用，Lín ē自動uì對方ê收藏suá掉。",
  "block_modal.remote_users_caveat": "Guán ē要求服侍器 {domain} 尊重lí ê決定。但是bô法度保證ta̍k ê服侍器lóng遵守，因為tsi̍t-kuá服侍器huân-sè用別款方法處理封鎖。公開ê PO文可能iáu是ē hōo bô登入ê用者看著。",
  "block_modal.show_less": "看khah少",
  "block_modal.show_more": "顯示其他ê內容",
  "block_modal.they_cant_mention": "Lín bē當提起、跟tuè，á是引用對方。",
  "block_modal.they_cant_see_posts": "In看無lí ê內容，lí mā看無in ê。",
  "block_modal.they_will_know": "In通看見in hőng封鎖。",
  "block_modal.title": "Kám beh封鎖用者？",
  "block_modal.you_wont_see_mentions": "Lí ē看無別lâng提起in ê PO文。",
  "boost_modal.combo": "後擺lí thang tshi̍h {combo} 跳過",
  "boost_modal.reblog": "Kám beh轉PO？",
  "boost_modal.undo_reblog": "Kám beh取消轉PO？",
  "bundle_column_error.copy_stacktrace": "Khóo-pih錯誤報告",
  "bundle_column_error.error.body": "請求ê頁bē-tàng 畫出來。有可能是guán程式碼內底ê錯誤，á是瀏覽器共存性ê議題。",
  "bundle_column_error.error.title": "害ah！",
  "bundle_column_error.network.body": "佇載入tsit頁ê時出現錯誤。可能因為lí ê網路連線á是tsit臺服侍器ê暫時ê問題。",
  "bundle_column_error.network.title": "網路錯誤",
  "bundle_column_error.retry": "Koh試",
  "bundle_column_error.return": "Tńg去頭頁",
  "bundle_column_error.routing.body": "Tshuē bô所要求ê頁面。Lí kám確定地址liâu-á ê URL正確？",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "關",
  "bundle_modal_error.message": "Tī載入tsit ê畫面ê時起錯誤。",
  "bundle_modal_error.retry": "Koh試",
  "callout.dismiss": "忽略",
  "carousel.current": "<sr>頁面</sr> {current, number} / {max, number}",
  "carousel.slide": "{max, number} 頁內底ê第 {current, number} 頁",
  "character_counter.recommended": "{currentLength}/{maxLength} ê建議字數",
  "character_counter.required": "{currentLength}/{maxLength} 字數",
  "closed_registrations.other_server_instructions": "因為Mastodon非中心化，所以lí ē當tī別ê服侍器建立口座，iáu ē當kap tsit ê服侍器來往。",
  "closed_registrations_modal.description": "Tann bē當tī {domain} 建立新ê口座，m̄-koh著記得，lí bô需要 {domain} 服侍器ê帳號，mā ē當用 Mastodon。",
  "closed_registrations_modal.find_another_server": "Tshuē別ê服侍器",
  "closed_registrations_modal.preamble": "因為Mastodon非中心化，所以bô論tī tá tsi̍t ê服侍器建立口座，lí lóng ē當跟tuè tsi̍t ê服侍器ê逐ê lâng，kap hām in交流。Lí iā ē當ka-tī起tsi̍t ê站！",
  "closed_registrations_modal.title": "註冊 Mastodon ê口座",
  "collection.share_modal.share_link_label": "分享連結",
  "collection.share_modal.share_via_post": "PO佇Mastodon頂",
  "collection.share_modal.share_via_system": "分享kàu……",
  "collection.share_modal.title": "分享收藏",
  "collection.share_modal.title_new": "分享lí ê新收藏！",
  "collection.share_template_other": "緊看覓chit ê時行ê收藏：{link}",
  "collection.share_template_own": "緊看覓我ê收藏：{link}",
  "collections.account_count": "{count, plural, other {# ê口座}}",
  "collections.accounts.empty_description": "加上tsē {count} ê口座",
  "collections.accounts.empty_editor_title": "Tsit ê 收藏內底iáu無半ê lâng",
  "collections.accounts.empty_title": "收藏內底無半項",
  "collections.block_collection_owner": "封鎖口座",
  "collections.by_account": "tuì {account_handle}",
  "collections.collection_description": "說明",
  "collections.collection_language": "語言",
  "collections.collection_language_none": "無",
  "collections.collection_name": "名",
  "collections.collection_topic": "主題",
  "collections.confirm_account_removal": "Lí確定beh對收藏suá掉tsit ê口座？",
  "collections.content_warning": "內容警告",
  "collections.continue": "繼續",
  "collections.copy_link": "Khóo-pih連結",
  "collections.copy_link_confirmation": "Khóo-pih收藏ê連結kàu剪貼簿á",
  "collections.create.accounts_title": "Lí想beh佇收藏內底予siáng標做特色ê？",
  "collections.create.basic_details_title": "基本ê資料",
  "collections.create.steps": "第 {step} 步，總共 {total} 步",
  "collections.create_collection": "建立收藏",
  "collections.delete_collection": "Thâi掉收藏",
  "collections.description_length_hint": "限制 100 字",
  "collections.detail.author_added_you_on_date": "{author} 佇 {date} kā lí加入",
  "collections.detail.loading": "載入收藏……",
  "collections.detail.revoke_inclusion": "Kā我suá掉",
  "collections.detail.sensitive_content": "敏感ê內容",
  "collections.detail.sensitive_note": "Tsit ê收藏包含對一寡用者敏感ê口座kap內容。",
  "collections.detail.share": "分享tsit ê收藏",
  "collections.detail.you_are_in_this_collection": "Lí已經hőng加kàu tsit ê收藏",
  "collections.edit_details": "編輯詳細",
  "collections.error_loading_collections": "佇試載入tsiah ê收藏ê時陣起錯誤。",
  "collections.hidden_accounts_description": "您有封鎖á是靜音{count, plural, one {tsit ê用者} other {tsiah ê用者}}",
  "collections.hidden_accounts_link": "{count, plural, other {# ê隱藏ê口座}}",
  "collections.hints.accounts_counter": "{count}/{max} ê口座",
  "collections.last_updated_at": "上尾更新tī：{date}",
  "collections.list.collections_with_count": "{count, plural, other {# 篇收藏}}",
  "collections.list.created_by_author": "由 {name} 所開",
  "collections.list.created_by_you": "由lí所開",
  "collections.list.featuring_you": "Lí佇收藏內底",
  "collections.manage_accounts": "管理口座",
  "collections.mark_as_sensitive": "標做敏感ê",
  "collections.mark_as_sensitive_hint": "Kā收藏ê描述kap口座tshàng佇內容警告ê後壁。收藏ê名猶原會當看。",
  "collections.maximum_collection_count_description": "Lí ê服侍器允准增加kàu上tsē {count} ê收藏。",
  "collections.maximum_collection_count_reached": "Lí已經建立kàu收藏數ê盡磅ah",
  "collections.name_length_hint": "限制 40 字",
  "collections.new_collection": "新ê收藏",
  "collections.pending_accounts.message": "佇guán leh等對用者iáu是in ê服侍器來ê回應ê時陣，口座可能ē顯示做等beh處理ê狀態。Kan-ta lí ē當看見等beh處理ê口座。",
  "collections.pending_accounts.title": "是án-nuá我ē看著leh等審查ê口座？",
  "collections.remove_account": "Suá掉",
  "collections.report_collection": "檢舉tsit ê收藏",
  "collections.revoke_collection_inclusion": "Kā我對收藏內底suá掉",
  "collections.revoke_inclusion.confirmation": "Lí已經對「{collection}」hőng suá掉",
  "collections.revoke_inclusion.error": "出tshê ah，請小等leh koh試。",
  "collections.search_accounts_label": "Tshuē口座來加添",
  "collections.search_accounts_max_reached": "Lí已經加kàu口座數ê盡磅ah。",
  "collections.sensitive": "敏感ê",
  "collections.share_short": "分享",
  "collections.suggestions.can_not_add": "Bē當hőng加添",
  "collections.suggestions.can_not_add_desc": "Tsiah ê口座可能選擇退出探索，或者是in可能佇無支援收藏ê服侍器頂。",
  "collections.suggestions.must_follow": "Lí著sing跟tuè",
  "collections.suggestions.must_follow_desc": "Tsiah ê口座審查所有跟tuè ê請求。跟tuè ê tsiah通kā in加入去收藏內底。",
  "collections.topic_hint": "加 hashtag，幫tsān別lâng了解tsit ê收藏ê主題。",
  "collections.topic_special_chars_hint": "儲存ê時陣ê suá掉特殊字元",
  "collections.unlisted_collections_description": "Chiah ê buē佇lí ê個人資料顯示予別lâng看。毋koh有tsit ê連結ê ē當發現in。",
  "collections.unlisted_collections_with_count": "無公開ê收藏（{count}）",
  "collections.view_collection": "看收藏",
  "collections.visibility_public": "公共ê",
  "collections.visibility_public_hint": "佇tshiau-tshuē結果kap別位有推薦ê所在通發現。",
  "collections.visibility_title": "通看ê程度",
  "collections.visibility_unlisted": "無公開",
  "collections.visibility_unlisted_hint": "有連結ê lâng通看見。佇tshiau-tshuē結果kap推薦內底bē當看。",
  "column.about": "概要",
  "column.blocks": "封鎖ê用者",
  "column.bookmarks": "冊籤",
  "column.community": "本地ê時間線",
  "column.create_list": "建立列單",
  "column.direct": "私人ê提起",
  "column.directory": "瀏覽個人資料",
  "column.domain_blocks": "封鎖ê域名",
  "column.edit_list": "編輯列單",
  "column.favourites": "Siōng kah意",
  "column.firehose": "Tsit-má ê動態",
  "column.firehose_local": "Tsit ê服侍器tsit-má ê動態",
  "column.firehose_singular": "Tsit-má ê動態",
  "column.follow_requests": "跟tuè請求",
  "column.home": "頭頁",
  "column.list_members": "管理列單ê成員",
  "column.lists": "列單",
  "column.mutes": "消音ê用者",
  "column.notifications": "通知",
  "column.other_collections": "{name} ê收藏",
  "column.pins": "釘起來ê PO文",
  "column.public": "聯邦ê時間線",
  "column.your_collections": "Lí ê收藏",
  "column_back_button.label": "頂頁",
  "column_header.hide_settings": "Khàm掉設定",
  "column_header.moveLeft_settings": "Kā欄sak khah倒pîng",
  "column_header.moveRight_settings": "Kā欄sak khah正pîng",
  "column_header.pin": "釘",
  "column_header.show_settings": "顯示設定",
  "column_header.unpin": "Pak掉",
  "column_search.cancel": "取消",
  "combobox.close_results": "關結果",
  "combobox.loading": "Leh載入",
  "combobox.no_results_found": "Tsit改tshuē無結果",
  "combobox.open_results": "開結果",
  "combobox.results_available": "{count, plural, other {# ê建議}}通好用。請用頂下方向khí suá tín動。Tshi̍h Enter khí來揀。",
  "community.column_settings.local_only": "Kan-ta展示本地ê",
  "community.column_settings.media_only": "Kan-ta展示媒體",
  "community.column_settings.remote_only": "Kan-ta展示遠距離ê",
  "compose.error.blank_post": "PO文bē當空白。",
  "compose.language.change": "換語言",
  "compose.language.search": "Tshiau-tshuē語言……",
  "compose.published.body": "成功PO文。",
  "compose.published.open": "開",
  "compose.saved.body": "PO文儲存ah。",
  "compose_form.direct_message_warning_learn_more": "詳細資訊",
  "compose_form.encryption_warning": "Mastodon ê PO文無點tuì點加密。M̄通用Mastodon分享任何敏感ê資訊。",
  "compose_form.hashtag_warning": "因為tsit êPO文m̄是公開ê，buē列tī任何ê hashtag。Kan-ta公開ê PO文tsiah ē當用hashtag tshuē。",
  "compose_form.lock_disclaimer": "Lí ê口座iáu buē {locked}。逐ê lâng lóng通跟tuè lí，看lí kan-ta hōo跟tuè ê看ê PO文。",
  "compose_form.lock_disclaimer.lock": "鎖起來ê",
  "compose_form.placeholder": "Lí teh想siánn？",
  "compose_form.poll.duration": "投票期間",
  "compose_form.poll.multiple": "Tsē選擇",
  "compose_form.poll.option_placeholder": "選項 {number}",
  "compose_form.poll.single": "單選擇",
  "compose_form.poll.switch_to_multiple": "Kā投票改做ē當選tsē-tsē ê。",
  "compose_form.poll.switch_to_single": "Kā投票改做kan-ta通選tsi̍t-ê",
  "compose_form.poll.type": "投票ê方法",
  "compose_form.publish": "PO文",
  "compose_form.reply": "回應",
  "compose_form.save_changes": "更新",
  "compose_form.spoiler.marked": "Thâi掉內容警告",
  "compose_form.spoiler.unmarked": "加添內容警告",
  "compose_form.spoiler_placeholder": "內容警告（m̄是必要）",
  "confirmation_modal.cancel": "取消",
  "confirmations.block.confirm": "封鎖",
  "confirmations.delete.confirm": "Thâi掉",
  "confirmations.delete.message": "Lí kám確定beh thâi掉tsit ê PO文？",
  "confirmations.delete.title": "Kám beh thâi掉tsit ê PO文？",
  "confirmations.delete_collection.confirm": "Thâi掉",
  "confirmations.delete_collection.message": "Tsit ê動作bē當復原。",
  "confirmations.delete_collection.title": "敢beh thâi掉「{name}」？",
  "confirmations.delete_list.confirm": "Thâi掉",
  "confirmations.delete_list.message": "Lí kám確定beh永永thâi掉tsit ê列單？",
  "confirmations.delete_list.title": "Kám beh thâi掉tsit ê列單？",
  "confirmations.discard_draft.confirm": "棄sak了後繼續",
  "confirmations.discard_draft.edit.cancel": "恢復編輯",
  "confirmations.discard_draft.edit.message": "Nā繼續，ē棄sak lí tuì當leh編輯ê PO文，所做ê任何改變。",
  "confirmations.discard_draft.edit.title": "Kám beh棄sak lí tuì PO文ê改變？",
  "confirmations.discard_draft.post.cancel": "恢復草稿",
  "confirmations.discard_draft.post.message": "nā繼續，ē棄sak lí當leh編寫ê PO文",
  "confirmations.discard_draft.post.title": "Kám beh棄sak lí PO文ê草稿？",
  "confirmations.discard_edit_media.confirm": "棄sak",
  "confirmations.discard_edit_media.message": "Lí佇媒體敘述á是先看māi ê所在有iáu buē儲存ê改變，kám beh kā in棄sak？",
  "confirmations.follow_to_list.confirm": "跟tuè，加入kàu列單",
  "confirmations.follow_to_list.message": "Beh kā {name} 加添kàu列單，lí tio̍h先跟tuè伊。",
  "confirmations.follow_to_list.title": "Kám beh跟tuè tsit ê用者？",
  "confirmations.hide_featured_tab.confirm": "Khàm掉分頁",
  "confirmations.hide_featured_tab.intro": "Lí不管時ē當佇<i>編輯個人資料→個人資料分頁設定</i>下kha改tse。",
  "confirmations.hide_featured_tab.message": "Tse ē kā佇 {serverName} kap別ê pháng上新版本ê Mastodon ê服侍器ê用者khàm掉分頁。其他界面ê顯示可能無kâng款。",
  "confirmations.hide_featured_tab.title": "敢beh khàm掉「精選ê」分頁？",
  "confirmations.logout.confirm": "登出",
  "confirmations.logout.message": "Lí kám確定beh登出？",
  "confirmations.logout.title": "Lí kám beh登出？",
  "confirmations.missing_alt_text.confirm": "加添說明文字",
  "confirmations.missing_alt_text.message": "Lí ê PO文包含無說明文字ê媒體。加添敘述，ē幫tsān lí ê內容hōo khah tsē lâng接近使用。",
  "confirmations.missing_alt_text.secondary": "就按呢PO出去",
  "confirmations.missing_alt_text.title": "Kám beh加添說明文字？",
  "confirmations.mute.confirm": "消音",
  "confirmations.private_quote_notify.cancel": "轉去編輯",
  "confirmations.private_quote_notify.confirm": "發布PO文",
  "confirmations.private_quote_notify.do_not_show_again": "Mài koh展示tsit ê訊息",
  "confirmations.private_quote_notify.message": "Lí所引用kap提起ê ē受通知，而且ē當看lí êPO文，就算in無跟tuè汝。",
  "confirmations.private_quote_notify.title": "Kám beh kap跟tuè lí ê hām所提起ê用者分享？",
  "confirmations.quiet_post_quote_info.dismiss": "請mài koh提醒我",
  "confirmations.quiet_post_quote_info.got_it": "知ah",
  "confirmations.quiet_post_quote_info.message": "Nā是引用無tī公共時間線內底êPO文，lí êPO文bē當tī趨勢ê時間線顯示。",
  "confirmations.quiet_post_quote_info.title": "引用無tī公開ê時間線內底顯示ê PO文",
  "confirmations.redraft.confirm": "Thâi掉了後重寫",
  "confirmations.redraft.message": "Lí kám確定beh thâi掉tsit篇PO文了後koh重寫？收藏kap轉PO ē無去，而且原底ê PO文ê回應ē變孤立。",
  "confirmations.redraft.title": "Kám beh thâi掉koh重寫PO文？",
  "confirmations.remove_from_followers.confirm": "Suá掉跟tuè lí ê",
  "confirmations.remove_from_followers.message": "{name} ē停止跟tuè lí。Lí kám確定beh繼續？",
  "confirmations.remove_from_followers.title": "Kám beh suá掉跟tuè lí ê?",
  "confirmations.revoke_collection_inclusion.confirm": "Kā我suá掉",
  "confirmations.revoke_collection_inclusion.message": "Tsit ê行動永永有效，了後建立收藏ê bē當kā lí重加kàu收藏內底。",
  "confirmations.revoke_collection_inclusion.title": "敢beh kā家kī對收藏內底suá掉？",
  "confirmations.revoke_quote.confirm": "Thâi掉PO文",
  "confirmations.revoke_quote.message": "Tsit ê動作bē當復原。",
  "confirmations.revoke_quote.title": "Kám beh thâi掉PO文？",
  "confirmations.unblock.confirm": "取消封鎖",
  "confirmations.unblock.title": "取消封鎖 {name}？",
  "confirmations.unfollow.confirm": "取消跟tuè",
  "confirmations.unfollow.title": "取消跟tuè {name}？",
  "confirmations.withdraw_request.confirm": "Kā跟tuè請求收tńg去",
  "confirmations.withdraw_request.title": "Kám beh收tńg去跟tuè {name} ê請求？",
  "content_warning.hide": "Am-khàm PO文",
  "content_warning.show": "Mā tio̍h顯示",
  "content_warning.show_more": "其他內容",
  "content_warning.show_short": "顯示",
  "conversation.delete": "Thâi掉會話",
  "conversation.mark_as_read": "標做有讀",
  "conversation.open": "顯示會話",
  "conversation.with": "Kap {names}",
  "copy_icon_button.copied": "有khóo-pih kàu tsián貼pang",
  "copy_icon_button.copy_this_text": "Khóo-pih連結kàu tsián貼pang",
  "copypaste.copied": "有khóo-pih",
  "copypaste.copy_to_clipboard": "Khóo-pih kàu tsián貼pang",
  "directory.federated": "Uì知影ê Fediverse",
  "directory.local": "Kan-ta uì {domain}",
  "directory.new_arrivals": "新來ê",
  "directory.recently_active": "最近活動ê",
  "disabled_account_banner.account_settings": "口座ê設定",
  "disabled_account_banner.text": "Lí ê口座 {disabledAccount} tsit-má hōo lâng停止使用。",
  "dismissable_banner.community_timeline": "Tsia sī uì 口座hē tī {domain} ê lâng，最近所公開PO ê。",
  "dismissable_banner.dismiss": "Mài kā tshah",
  "dismissable_banner.public_timeline": "Tsiah ê是 {domain} 內底ê lâng 佇 Fediverse所跟tuè ê ê，上新ê公開PO文。.",
  "domain_block_modal.block": "封鎖服侍器",
  "domain_block_modal.block_account_instead": "改做封鎖 @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Uì tsit ê服侍器來ê，通kap lí khah早ê PO交流。",
  "domain_block_modal.they_cant_follow": "Tuì tsit ê服侍器來ê 通跟tuè lí。",
  "domain_block_modal.they_wont_know": "In buē知影in受封鎖。",
  "domain_block_modal.title": "Kám beh封鎖域名？",
  "domain_block_modal.you_will_lose_num_followers": "Lí ē失去 {followersCount, plural, other {{followersCountDisplay} ê lâng跟tuè}} kap {followingCount, plural, other {{followingCountDisplay} ê lí所tuè ê 口座}}。",
  "domain_block_modal.you_will_lose_relationships": "Lí ē失去逐ê佇tsit ê服侍器跟tuè lí ê，kap lí所跟tuè ê。",
  "domain_block_modal.you_wont_see_posts": "Lí buē看見tsit ê服侍器ê用者所送ê PO文kap通知。",
  "domain_pill.activitypub_lets_connect": "伊ē hōo lí kap Mastodon ê lâng連結kap互動，其他社交應用程式ê lâng mā ē使。",
  "domain_pill.activitypub_like_language": "ActivityPub親像Mastodon kap其他社交應用程式所講ê語言。",
  "domain_pill.server": "服侍器",
  "domain_pill.their_handle": "In ê口座：",
  "domain_pill.their_server": "In數位ê tau，in所有ê PO文lóng tī tsia。",
  "domain_pill.their_username": "In佇in ê服侍器獨一ê稱呼。佇無kâng ê服侍器有可能tshuē著kāng名ê用者。",
  "domain_pill.username": "用者ê名",
  "domain_pill.whats_in_a_handle": "口座是siánn-mih？",
  "domain_pill.who_they_are": "因為口座(handle)表示tsit ê lâng是siáng kap tī toh，lí ē當佇<button>支援ActivityPub ê平臺</button>. ê社交網路kap lâng交流。",
  "domain_pill.who_you_are": "因為口座(handle)表示lí是siáng kap tī toh，lâng ē當佇<button>支援ActivityPub ê平臺</button>. ê社交網路kap lí交流。",
  "domain_pill.your_handle": "Lí ê口座：",
  "domain_pill.your_server": "Lí數位ê厝，內底有lí所有ê PO文。無kah意？Ē當轉kàu別ê服侍器，koh保有跟tuè lí êl âng。.",
  "domain_pill.your_username": "Lí 佇tsit ê服侍器獨一ê稱呼。佇無kâng ê服侍器有可能tshuē著kāng名ê用者。",
  "dropdown.empty": "揀選項",
  "email_subscriptions.email": "電子phue箱",
  "email_subscriptions.form.action": "訂",
  "email_subscriptions.form.bottom": "無開Mastodon ê口座，mā ē當佇收件箱收著PO文。不管時lóng ē當取消訂。其他資訊，請參考<a>隱私權政策</a>。",
  "email_subscriptions.form.title": "訂 {name} ê電子phue更新",
  "email_subscriptions.submitted.lead": "請檢查lí ê收件箱來完成訂電子批ê更新。",
  "email_subscriptions.submitted.title": "上尾步",
  "email_subscriptions.validation.email.blocked": "封鎖ê電子phue箱提供者",
  "email_subscriptions.validation.email.invalid": "無效ê電子phue地址",
  "embed.instructions": "Khóo-pih 下kha ê程式碼，來kā tsit篇PO文tàu佇lí ê網站。",
  "embed.preview": "伊e án-ne顯示：\n",
  "emoji_button.activity": "活動",
  "emoji_button.clear": "清掉",
  "emoji_button.custom": "自訂ê",
  "emoji_button.flags": "旗á",
  "emoji_button.food": "Tsia̍h-mi̍h kap 飲料",
  "emoji_button.label": "加入繪文字(emoji)",
  "emoji_button.nature": "自然",
  "emoji_button.not_found": "Tshuē無對應ê emoji",
  "emoji_button.objects": "物件",
  "emoji_button.people": "Lâng",
  "emoji_button.recent": "Tsia̍p用ê",
  "emoji_button.search": "Tshiau-tshuē……",
  "emoji_button.search_results": "Tshiau-tshuē ê結果",
  "emoji_button.symbols": "符號",
  "emoji_button.travel": "旅行kap地點",
  "empty_column.account_featured.other": "{acct} iáu無收藏半ê。",
  "empty_column.account_featured_self.no_collections_button": "建立收藏",
  "empty_column.account_featured_self.no_collections_hide_tab": "改做隱藏tsit ê分頁",
  "empty_column.account_featured_self.pre_collections": "請期待收藏",
  "empty_column.account_featured_self.pre_collections_desc": "收藏（佇Mastodon 4.6推出）予lí建立家己ê精選口座列單，來推薦予別lâng。",
  "empty_column.account_featured_self.showcase_accounts": "展示lí上kah意ê口座",
  "empty_column.account_featured_self.showcase_accounts_desc": "收藏是精選ê口座列單，幫tsān別lâng探索聯邦宇宙ê其他內容。",
  "empty_column.account_featured_unknown.other": "Tsit ê口座iáu無收藏siánn物。",
  "empty_column.account_hides_collections": "Tsit位用者選擇無愛公開tsit ê資訊",
  "empty_column.account_suspended": "口座已經受停止",
  "empty_column.account_timeline": "Tsia無PO文！",
  "empty_column.account_unavailable": "個人資料bē當看",
  "empty_column.blocks": "Lí iáu無封鎖任何用者。",
  "empty_column.bookmarked_statuses": "Lí iáu無加添任何冊籤。Nā是lí加添冊籤，伊ē佇tsia顯示。",
  "empty_column.collections.featured_in": "Lí iáu buē加添kàu任何收藏。",
  "empty_column.community": "本站時間線是空ê。緊來公開PO文oh！",
  "empty_column.direct": "Lí iáu無任何ê私人訊息。Nā是lí送á是收著私人訊息，ē佇tsia顯示。.",
  "empty_column.disabled_feed": "Tsit ê feed已經hōo lí ê服侍器ê管理員停用。",
  "empty_column.domain_blocks": "Iáu無封鎖任何域名。",
  "empty_column.explore_statuses": "目前iáu無有流行ê趨勢，請sió等tsi̍t-ē，koh確認。",
  "empty_column.favourited_statuses": "Lí iáu無加添任何收藏 ê PO文。Nā是lí加收藏，伊ē佇tsia顯示。",
  "empty_column.favourites": "Iáu無lâng收藏tsit篇PO文。Nā是有lâng收藏，ē佇tsia顯示。",
  "empty_column.follow_requests": "Lí iáu buē收著任何ê跟tuè請求。Nā是lí收著，伊ē佇tsia顯示。",
  "empty_column.followed_tags": "Lí iáu buē收著任何ê hashtag。Nā是lí收著，ē佇tsia顯示。",
  "empty_column.hashtag": "Tsit ê hashtag內底無物件。",
  "empty_column.home": "Lí tshù ê時間線是空ê！跟tuè別lâng來kā充滿。",
  "empty_column.list": "Tsit張列單內底iáu bô物件。若是列單內底ê成員貼新ê PO文，in ē tī tsia顯示。",
  "empty_column.mutes": "Lí iáu無消音任何用者。",
  "empty_column.notification_requests": "清hōo空ah！內底無物件。若是lí收著新ê通知，ē根據lí ê設定，佇tsia出現。",
  "empty_column.notifications": "Lí iáu無收著任何通知。Nā別lâng kap lí互動，lí ē佇tsia看著。",
  "empty_column.public": "內底無物件！寫beh公開ê PO文，á是主動跟tuè別ê服侍器ê用者，來加添內容。",
  "empty_state.no_results": "無結果",
  "error.no_hashtag_feed_access": "加入á是登入，來看kap跟tuè tsit ê hashtag。",
  "error.unexpected_crash.explanation": "因為原始碼內底有錯誤，á是瀏覽器相容出tshê，tsit頁bē當正確顯示。",
  "error.unexpected_crash.explanation_addons": "Tsit頁bē當正確顯示，可能是瀏覽器附ê功能，á是自動翻譯工具所致。",
  "error.unexpected_crash.next_steps": "請試更新tsit頁。若是bē當改善，lí iáu是ē當改使用無kâng ê瀏覽器，á是app，來用Mastodon。",
  "error.unexpected_crash.next_steps_addons": "請試kā in停止使用，suà落來更新tsit頁。若是bē當改善，lí iáu是ē當改使用無kâng ê瀏覽器，á是app，來用Mastodon。",
  "errors.unexpected_crash.copy_stacktrace": "Khóo-pih stacktrace kàu剪貼pang-á",
  "errors.unexpected_crash.report_issue": "報告問題",
  "explore.suggested_follows": "用者",
  "explore.title": "趨勢",
  "explore.trending_links": "新聞",
  "explore.trending_statuses": "PO文",
  "explore.trending_tags": "Hashtag",
  "featured_carousel.current": "<sr>PO文</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {{counter} 篇} other {{counter} 篇}} 釘起來ê PO文",
  "featured_carousel.slide": "{max, number} 篇PO文內底ê第 {current, number} 篇",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Tsit tsām-á lí有PO關係{items} ê文。敢beh加tsiah ê kàu 特色ê hashtag？",
  "featured_tags.suggestions.add": "加",
  "featured_tags.suggestions.added": "請隨時佇<link>編輯個人資料 > 特色hashtag</link>管理lí ê特色hashtag。",
  "featured_tags.suggestions.dismiss": "毋免，多謝。",
  "filter_modal.added.context_mismatch_explanation": "Tsit ê過濾器類別bē當適用佇lí所接近使用ê PO文ê情境。若是lí mā beh佇tsit ê情境過濾tsit ê PO文，lí著編輯過濾器。.",
  "filter_modal.added.context_mismatch_title": "本文無sio合！",
  "filter_modal.added.expired_explanation": "Tsit ê過濾器類別過期ah，lí需要改到期ê日期來繼續用。",
  "filter_modal.added.expired_title": "過期ê過濾器",
  "filter_modal.added.review_and_configure": "Beh審視kap進前設定tsit ê過濾器ê類別，請kàu {settings_link}。",
  "filter_modal.added.review_and_configure_title": "過濾器ê設定",
  "filter_modal.added.settings_link": "設定頁",
  "filter_modal.added.short_explanation": "Tsit ê PO文已經加添kàu下kha ê過濾器類別：{title}。",
  "filter_modal.added.title": "過濾器加添ah！",
  "filter_modal.select_filter.context_mismatch": "Mài用tī tsit ê內文",
  "filter_modal.select_filter.expired": "過期ah",
  "filter_modal.select_filter.prompt_new": "新ê類別：{name}",
  "filter_modal.select_filter.search": "Tshiau-tshuē á是加添",
  "filter_modal.select_filter.subtitle": "用有ê類別á是建立新ê",
  "filter_modal.select_filter.title": "過濾tsit篇PO文",
  "filter_modal.title.status": "過濾PO文",
  "filter_warning.matches_filter": "合過濾器「<span>{title}</span>」",
  "filtered_notifications_banner.pending_requests": "Tuì lí可能熟sāi ê {count, plural, =0 {0 ê人} other {# ê人}}",
  "filtered_notifications_banner.title": "過濾ê通知",
  "firehose.all": "Kui ê",
  "firehose.local": "Tsit ê服侍器",
  "firehose.remote": "別ê服侍器",
  "follow_request.authorize": "授權",
  "follow_request.reject": "拒絕",
  "follow_requests.unlocked_explanation": "就算lí ê口座無hőng鎖，{domain} ê管理員leh想，lí可能beh手動審查tuì tsiah ê口座送ê跟tuè請求。",
  "follow_suggestions.curated_suggestion": "精選ê內容",
  "follow_suggestions.dismiss": "Mài koh顯示。",
  "follow_suggestions.featured_longer": "{domain} 團隊所揀ê",
  "follow_suggestions.friends_of_friends_longer": "時行佇lí所tuè ê lâng",
  "follow_suggestions.hints.featured": "Tsit ê個人資料是 {domain} 團隊特別揀ê。",
  "follow_suggestions.hints.friends_of_friends": "Tsit ê個人資料tī lí跟tuè ê lâng之間真流行。",
  "follow_suggestions.hints.most_followed": "Tsit ê個人資料是 {domain} 內，有足tsē跟tuè者ê其中tsit ê。",
  "follow_suggestions.hints.most_interactions": "Tsit ê個人資料tsi̍t-tsām-á佇 {domain} 有得著真tsē關注。",
  "follow_suggestions.hints.similar_to_recently_followed": "Tsit ê個人資料kap lí最近跟tuè ê口座相siâng。",
  "follow_suggestions.personalized_suggestion": "個人化ê推薦",
  "follow_suggestions.popular_suggestion": "流行ê推薦",
  "follow_suggestions.popular_suggestion_longer": "佇{domain} 足有lâng緣",
  "follow_suggestions.similar_to_recently_followed_longer": "Kap lí最近跟tuè ê相siâng",
  "follow_suggestions.view_all": "看全部",
  "follow_suggestions.who_to_follow": "Thang tuè ê",
  "followed_tags": "跟tuè ê hashtag",
  "followers.hide_other_followers": "Tsit位用者選擇mài公開跟tuè伊ê",
  "followers.title": "Teh跟tuè {name}",
  "following.hide_other_following": "Tsit位用者選擇mài公開伊跟tuè ê別lâng",
  "following.title": "Hōo {name} 跟tuè",
  "footer.about": "概要",
  "footer.about_mastodon": "關係Mastodon",
  "footer.about_server": "關係 {domain}",
  "footer.about_this_server": "關係本站",
  "footer.directory": "個人資料ê目錄",
  "footer.get_app": "The̍h著app",
  "footer.keyboard_shortcuts": "鍵盤kiu-té khí (shortcut)",
  "footer.privacy_policy": "隱私權政策",
  "footer.source_code": "看原始碼",
  "footer.status": "狀態",
  "footer.terms_of_service": "服務規定",
  "form_error.blank": "框á bē當空白。",
  "form_field.optional": "（通揀）",
  "generic.saved": "儲存ah",
  "getting_started.heading": "開始用",
  "hashtag.admin_moderation": "Phah開 #{name} ê管理界面",
  "hashtag.browse": "瀏覽佇 #{hashtag} ê PO文",
  "hashtag.browse_from_account": "瀏覽 @{name} 佇 #{hashtag} 所寫ê PO文",
  "hashtag.column_header.tag_mode.all": "kap {additional}",
  "hashtag.column_header.tag_mode.any": "á是 {additional}",
  "hashtag.column_header.tag_mode.none": "無需要 {additional}",
  "hashtag.column_settings.select.no_options_message": "Tshuē無建議",
  "hashtag.column_settings.select.placeholder": "請輸入hashtag……",
  "hashtag.column_settings.tag_mode.all": "Kui ê",
  "hashtag.column_settings.tag_mode.any": "任何tsi̍t ê",
  "hashtag.column_settings.tag_mode.none": "Lóng mài",
  "hashtag.column_settings.tag_toggle": "Kā追加ê標籤加添kàu tsit ê欄",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} ê} other {{counter} ê}}參與ê",
  "hashtag.counter_by_uses": "{count, plural, other {{counter} 篇PO文}}",
  "hashtag.counter_by_uses_today": "Kin-á日有 {count, plural, one {{counter} 篇} other {{counter} 篇}}PO文",
  "hashtag.feature": "Tī個人資料推薦",
  "hashtag.follow": "跟tuè hashtag",
  "hashtag.mute": "消音 #{hashtag}",
  "hashtag.unfeature": "Mài tī個人資料推薦",
  "hashtag.unfollow": "取消跟tuè hashtag",
  "hashtags.and_other": "……kap 其他 {count, plural, other {# ê}}",
  "hints.profiles.followers_may_be_missing": "Tsit ê個人資料ê跟tuè者資訊可能有落勾ê。",
  "hints.profiles.follows_may_be_missing": "Tsit ê口座所跟tuè ê ê資訊可能有落勾ê。",
  "hints.profiles.posts_may_be_missing": "Tsit ê口座ê tsi̍t kuá PO文可能有落勾ê。",
  "hints.profiles.see_more_followers": "佇 {domain} 看koh khah tsē跟tuè lí ê",
  "hints.profiles.see_more_follows": "佇 {domain} 看koh khah tsē lí跟tuè ê",
  "hints.profiles.see_more_posts": "佇 {domain} 看koh khah tsē ê PO文",
  "home.column_settings.show_quotes": "顯示引用",
  "home.column_settings.show_reblogs": "顯示轉PO",
  "home.column_settings.show_replies": "顯示回應",
  "home.hide_announcements": "Khàm掉公告",
  "home.pending_critical_update.body": "請liōng早更新lí ê Mastodon ê服侍器！",
  "home.pending_critical_update.link": "看更新內容",
  "home.pending_critical_update.title": "有重要ê安全更新！",
  "home.show_announcements": "顯示公告",
  "ignore_notifications_modal.disclaimer": "Lí所忽略in ê通知ê用者，Mastodonbē當kā lí通知。忽略通知bē當阻擋訊息ê寄送。",
  "ignore_notifications_modal.filter_instead": "改做過濾",
  "ignore_notifications_modal.filter_to_act_users": "Lí猶原ē當接受、拒絕猶是檢舉用者",
  "ignore_notifications_modal.filter_to_avoid_confusion": "過濾ē當避免可能ê bē分明。",
  "ignore_notifications_modal.filter_to_review_separately": "Lí ē當個別檢視所過濾ê通知",
  "ignore_notifications_modal.ignore": "Kā通知忽略",
  "ignore_notifications_modal.limited_accounts_title": "Kám beh忽略受限制ê口座送來ê通知？",
  "ignore_notifications_modal.new_accounts_title": "Kám beh忽略新口座送來ê通知？",
  "ignore_notifications_modal.not_followers_title": "Kám beh忽略無跟tuè lí ê口座送來ê通知？",
  "ignore_notifications_modal.not_following_title": "Kám beh忽略lí 無跟tuè ê口座送來ê通知？",
  "ignore_notifications_modal.private_mentions_title": "忽略ka-kī主動送ê私人提起ê通知？",
  "info_button.label": "幫tsān",
  "info_button.what_is_alt_text": "<h1>Siánn物是替代文字？</h1> <p>替代文字kā視覺有障礙、網路速度khah慢，á是beh tshuē頂下文ê lâng，提供圖ê敘述。</p> <p>Lí ē當通過寫明白、簡單kap客觀ê替代文字，替逐家改善容易使用性kap幫tsān理解。</p> <ul> <li>掌握重要ê因素</li> <li>替圖寫摘要ê文字</li> <li>用規則ê語句結構</li> <li>避免重複ê資訊</li> <li>專注佇趨勢kap佇複雜視覺（比如圖表á是地圖）內底tshuē關鍵</li> </ul>",
  "interaction_modal.action": "Nā beh hām {name} ê PO文互動，lí愛佇lí所用ê Mastodon服侍器登入口座。",
  "interaction_modal.action_follow": "Nā beh跟tuè {name}，lí著佇lí所用ê服侍器登入lí ê口座。",
  "interaction_modal.go": "行",
  "interaction_modal.no_account_yet": "Tsit-má iáu bô口座？",
  "interaction_modal.on_another_server": "佇無kâng ê服侍器",
  "interaction_modal.on_this_server": "Tī tsit ê服侍器",
  "interaction_modal.title": "登入koh繼續",
  "interaction_modal.username_prompt": "比如：{example}",
  "intervals.full.days": "{number, plural, other {# kang}}",
  "intervals.full.hours": "{number, plural, other {# 點鐘}}",
  "intervals.full.minutes": "{number, plural, other {# 分鐘}}",
  "keyboard_shortcuts.back": "Tńg去",
  "keyboard_shortcuts.blocked": "開封鎖ê用者ê列單",
  "keyboard_shortcuts.boost": "轉送PO文",
  "keyboard_shortcuts.column": "揀tsit ê欄",
  "keyboard_shortcuts.compose": "揀寫文字ê框仔",
  "keyboard_shortcuts.description": "說明",
  "keyboard_shortcuts.direct": "Phah開私人提起ê欄",
  "keyboard_shortcuts.down": "佇列單內kā suá khah 下kha",
  "keyboard_shortcuts.enter": "Phah開PO文",
  "keyboard_shortcuts.explore": "拍開趨勢ê時間線",
  "keyboard_shortcuts.favourite": "收藏PO文",
  "keyboard_shortcuts.favourites": "Phah開收藏ê列單",
  "keyboard_shortcuts.federated": "Phah開聯邦ê時間線",
  "keyboard_shortcuts.heading": "鍵盤ê快速key",
  "keyboard_shortcuts.home": "Phah開tshù ê時間線",
  "keyboard_shortcuts.hotkey": "快速key",
  "keyboard_shortcuts.legend": "顯示tsit篇說明",
  "keyboard_shortcuts.load_more": "Kā焦點suá kàu「載入其他」ê鈕仔",
  "keyboard_shortcuts.local": "Phah開本站ê時間線",
  "keyboard_shortcuts.mention": "提起作者",
  "keyboard_shortcuts.muted": "Phah開消音ê用者列單",
  "keyboard_shortcuts.my_profile": "Phah開lí ê個人資料",
  "keyboard_shortcuts.notifications": "Phah開通知欄",
  "keyboard_shortcuts.open_media": "Phah開媒體",
  "keyboard_shortcuts.pinned": "Phah開釘起來ê PO文列單",
  "keyboard_shortcuts.profile": "Phah開作者ê個人資料",
  "keyboard_shortcuts.quote": "引用PO文",
  "keyboard_shortcuts.reply": "回應PO文",
  "keyboard_shortcuts.requests": "Phah開跟tuè請求ê列單",
  "keyboard_shortcuts.search": "揀tshiau-tshuē條á",
  "keyboard_shortcuts.spoilers": "顯示／隱藏內容警告",
  "keyboard_shortcuts.start": "Phah開「開始用」欄",
  "keyboard_shortcuts.toggle_hidden": "顯示／隱藏內容警告後壁ê PO文",
  "keyboard_shortcuts.toggle_sensitivity": "顯示／tshàng媒體",
  "keyboard_shortcuts.toot": "PO新PO文",
  "keyboard_shortcuts.top": "Súa kàu列單ê頭",
  "keyboard_shortcuts.translate": "kā PO文翻譯",
  "keyboard_shortcuts.unfocus": "離開輸入框仔／tshiau-tshuē格仔",
  "keyboard_shortcuts.up": "佇列單內kā suá khah面頂",
  "learn_more_link.got_it": "知矣",
  "learn_more_link.learn_more": "看詳細",
  "lightbox.close": "關",
  "lightbox.next": "下tsi̍t ê",
  "lightbox.previous": "頂tsi̍t ê",
  "lightbox.zoom_in": "Tshūn-kiu kàu實際ê sài-suh",
  "lightbox.zoom_out": "Tshūn-kiu kàu適當ê sài-suh",
  "limited_account_hint.action": "一直顯示個人資料",
  "limited_account_hint.title": "Tsit ê 個人資料予 {domain} ê管理員tshàng起來ah。",
  "link_preview.author": "Tuì {name}",
  "link_preview.more_from_author": "看 {name} ê其他內容",
  "link_preview.shares": "{count, plural, one {{counter} 篇} other {{counter} 篇}}PO文",
  "lists.add_member": "加",
  "lists.add_to_list": "加添kàu列單",
  "lists.add_to_lists": "Kā {name} 加添kàu列單",
  "lists.create": "建立",
  "lists.create_a_list_to_organize": "開新ê列單，組織lí tshù ê時間線",
  "lists.create_list": "建立列單",
  "lists.delete": "Thâi掉列單",
  "lists.done": "做好ah",
  "lists.edit": "編輯列單",
  "lists.exclusive": "佇tshù ê時間線kā成員tshàng起來。",
  "lists.exclusive_hint": "Nā bóo-mi̍h口座佇tsit ê列單，ē tuì lí tshù ê時間線kā tsit ê口座tshàng起來，避免koh看見in ê PO文。",
  "lists.find_users_to_add": "Tshuē beh加添ê用者",
  "lists.list_members_count": "{count, plural, other {# 位成員}}",
  "lists.list_name": "列單ê名",
  "lists.new_list_name": "新ê列單ê名",
  "lists.no_lists_yet": "Iáu無列單。",
  "lists.no_members_yet": "Iáu無成員。",
  "lists.no_results_found": "Tshuē無結果。",
  "lists.remove_member": "Suá掉",
  "lists.replies_policy.followed": "所跟tuè ê任何用者",
  "lists.replies_policy.list": "列單ê成員",
  "lists.replies_policy.none": "無半位",
  "lists.save": "儲存",
  "lists.search": "Tshiau-tshuē",
  "lists.show_replies_to": "列單成員回應ê顯示範圍",
  "load_pending": "{count, plural, other {# ê 項目}}",
  "loading_indicator.label": "Leh載入……",
  "media_gallery.hide": "Khàm掉",
  "moved_to_account_banner.text": "Lí ê口座 {disabledAccount} 已經停止使用ah，因為suá kàu {movedToAccount}。",
  "mute_modal.hide_from_notifications": "Tuì通知內底khàm掉",
  "mute_modal.hide_options": "Khàm掉選項",
  "mute_modal.indefinite": "直到我取消消音",
  "mute_modal.show_options": "顯示選項",
  "mute_modal.they_can_mention_and_follow": "In iáu ē當提起á是跟tuè lí，毋過lí看buē著in。",
  "mute_modal.they_wont_know": "In buē知影in受消音。",
  "mute_modal.title": "Kā用者消音？",
  "mute_modal.you_wont_see_mentions": "Lí buē看見提起in ê PO文。",
  "mute_modal.you_wont_see_posts": "In iáu ē當看著lí ê PO文，毋過lí看bē tio̍h in ê。",
  "navigation_bar.about": "概要",
  "navigation_bar.account_settings": "密碼kap安全",
  "navigation_bar.administration": "管理",
  "navigation_bar.advanced_interface": "用進階ê網頁界面開",
  "navigation_bar.automated_deletion": "自動thâi PO文",
  "navigation_bar.blocks": "封鎖ê用者",
  "navigation_bar.bookmarks": "冊籤",
  "navigation_bar.collections": "收藏",
  "navigation_bar.direct": "私人ê提起",
  "navigation_bar.domain_blocks": "封鎖ê域名",
  "navigation_bar.favourites": "Siōng kah意",
  "navigation_bar.filters": "消音ê詞",
  "navigation_bar.follow_requests": "跟tuè請求",
  "navigation_bar.followed_tags": "跟tuè ê hashtag",
  "navigation_bar.follows_and_followers": "Leh跟tuè ê kap跟tuè lí ê",
  "navigation_bar.import_export": "輸入kap輸出",
  "navigation_bar.lists": "列單",
  "navigation_bar.live_feed_local": "即時ê內容（本地）",
  "navigation_bar.live_feed_public": "即時ê內容（公開）",
  "navigation_bar.logout": "登出",
  "navigation_bar.moderation": "管理",
  "navigation_bar.more": "其他",
  "navigation_bar.mutes": "消音ê用者",
  "navigation_bar.opened_in_classic_interface": "PO文、口座kap其他指定ê頁面，預設ē佇經典ê網頁界面內phah開。",
  "navigation_bar.preferences": "偏愛ê設定",
  "navigation_bar.privacy_and_reach": "隱私kap資訊ê及至",
  "navigation_bar.search": "Tshiau-tshuē",
  "navigation_bar.search_trends": "Tshiau-tshuē / 趨勢",
  "navigation_panel.collapse_followed_tags": "Kā跟tuè ê hashtag目錄嵌起來",
  "navigation_panel.collapse_lists": "Khàm掉列單目錄",
  "navigation_panel.expand_followed_tags": "Kā跟tuè ê hashtag目錄thián開",
  "navigation_panel.expand_lists": "Thián開列單目錄",
  "not_signed_in_indicator.not_signed_in": "Lí著登入來接近使用tsit ê資源。",
  "notification.added_to_collection": "{name} kā lí加kàu收藏",
  "notification.admin.report": "{name} kā {target} 檢舉ah",
  "notification.admin.report_account": "{name} kā {target} 所寫ê {count, plural, other {# 篇PO文}}檢舉ah，原因是：{category}",
  "notification.admin.report_account_other": "{name} kā {target} 所寫ê {count, plural, other {# 篇PO文}}檢舉ah",
  "notification.admin.report_statuses": "{name} kā {target} 檢舉ah，原因是：{category}",
  "notification.admin.report_statuses_other": "{name} kā {target} 檢舉ah",
  "notification.admin.sign_up": "口座 {name} 有開ah。",
  "notification.admin.sign_up.name_and_others": "{name} kap {count, plural, other {其他 # ê lâng}} ê口座有開ah",
  "notification.annual_report.message": "Lí ê {year} #Wrapstodon teh等lí！緊來看tsit年lí佇Mastodon頂ê上精彩ê內容，kap難忘ê時刻！",
  "notification.annual_report.view": "Kā #Wrapstodon 看māi。",
  "notification.favourite": "{name} kah意lí ê PO文",
  "notification.favourite.name_and_others_with_link": "{name} kap<a>{count, plural, other {另外 # ê lâng}}</a>kah意lí ê PO文",
  "notification.favourite_pm": "{name} kah意lí ê私人ê提起",
  "notification.favourite_pm.name_and_others_with_link": "{name} kap<a>{count, plural, other {另外 # ê lâng}}</a>kah意lí ê私人ê提起",
  "notification.follow": "{name}跟tuè lí",
  "notification.follow.name_and_others": "{name} kap<a>{count, plural, other {另外 # ê lâng}}</a>跟tuè lí",
  "notification.follow_request": "{name} 請求跟tuè lí",
  "notification.follow_request.name_and_others": "{name} kap{count, plural, other {另外 # ê lâng}}請求跟tuè lí",
  "notification.label.mention": "提起",
  "notification.label.private_mention": "私人ê提起",
  "notification.label.private_reply": "私人ê回應",
  "notification.label.quote": "{name} 引用lí ê PO文",
  "notification.label.reply": "回應",
  "notification.mention": "提起",
  "notification.mentioned_you": "{name}kā lí提起",
  "notification.moderation-warning.learn_more": "看詳細",
  "notification.moderation_warning": "Lí有收著管理ê警告",
  "notification.moderation_warning.action_delete_statuses": "Lí ê一寡PO文hōo lâng thâi掉ah。",
  "notification.moderation_warning.action_disable": "Lí ê口座hōo lâng停止使用ah。",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Lí ê一寡PO文，hōo lâng標做敏感ê內容。",
  "notification.moderation_warning.action_none": "Lí ê口座有收著管理ê警告。",
  "notification.moderation_warning.action_sensitive": "Tuì tsit-má開始，lí êPO文ē標做敏感ê內容。",
  "notification.moderation_warning.action_silence": "Lí ê口座hōo lâng限制ah。",
  "notification.moderation_warning.action_suspend": "Lí ê口座ê權限已經停止ah。",
  "notification.own_poll": "Lí ê投票結束ah",
  "notification.poll": "Lí bat投ê投票結束ah",
  "notification.quoted_update": "{name} 編輯lí有引用ê PO文",
  "notification.reblog": "{name} 轉送lí ê PO文",
  "notification.reblog.name_and_others_with_link": "{name} kap<a>{count, plural, other {另外 # ê lâng}}</a>轉送lí ê PO文",
  "notification.relationships_severance_event": "Kap {name} ê結連無去",
  "notification.relationships_severance_event.account_suspension": "{from} ê管理員kā {target} 停止權限ah，意思是lí bē koh再接受tuì in 來ê更新，á是hām in互動。",
  "notification.relationships_severance_event.domain_block": "{from} ê 管理員kā {target} 封鎖ah，包含 {followersCount} 位跟tuè lí ê lâng，kap {followingCount, plural, other {#}} 位lí跟tuè ê口座。",
  "notification.relationships_severance_event.learn_more": "看詳細",
  "notification.relationships_severance_event.user_domain_block": "Lí已經kā {target} 封鎖ah，ē suá走 {followersCount} 位跟tuè lí ê lâng，kap {followingCount, plural, other {#}} 位lí跟tuè ê口座。",
  "notification.status": "{name} tú-á PO",
  "notification.update": "{name}有編輯PO文",
  "notification_requests.accept": "接受",
  "notification_requests.accept_multiple": "{count, plural, other {接受 # ê請求……}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, other {接受請求}}",
  "notification_requests.confirm_accept_multiple.message": "Lí teh-beh接受 {count, plural,  other {# ê 通知ê請求}}。Lí kám確定beh繼續？",
  "notification_requests.confirm_accept_multiple.title": "接受通知ê請求？",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, other {忽略請求}}",
  "notification_requests.confirm_dismiss_multiple.message": "Lí teh-beh忽略 {count, plural, other {# ê 通知ê請求}}。Lí bē當koh容易the̍h著{count, plural, other {tsiah-ê}} 通知。Lí kám確定beh繼續？",
  "notification_requests.confirm_dismiss_multiple.title": "忽略通知ê請求？",
  "notification_requests.dismiss": "忽略",
  "notification_requests.dismiss_multiple": "{count, plural, other {忽略 # ê請求……}}",
  "notification_requests.edit_selection": "編輯",
  "notification_requests.exit_selection": "做好ah",
  "notification_requests.explainer_for_limited_account": "因為管理員限制tsit ê口座，tuì tsit ê口座來ê通知已經hōo過濾ah。",
  "notification_requests.explainer_for_limited_remote_account": "因為管理員限制tsit ê口座á是伊ê服侍器，tuì tsit ê口座來ê通知已經hōo過濾ah。",
  "notification_requests.maximize": "上大化",
  "notification_requests.minimize_banner": "上細化受過濾ê通知ê條á",
  "notification_requests.notifications_from": "Tuì {name} 來ê通知",
  "notification_requests.title": "受過濾ê通知",
  "notification_requests.view": "看通知",
  "notifications.clear": "清掉通知",
  "notifications.clear_confirmation": "Lí kám確定beh永永清掉lí所有ê通知？",
  "notifications.clear_title": "清掉通知？",
  "notifications.column_settings.admin.report": "新ê檢舉：",
  "notifications.column_settings.admin.sign_up": "新註冊ê口座：",
  "notifications.column_settings.alert": "桌面ê通知",
  "notifications.column_settings.favourite": "收藏：",
  "notifications.column_settings.filter_bar.advanced": "顯示逐ê類別",
  "notifications.column_settings.filter_bar.category": "快速ê過濾器",
  "notifications.column_settings.follow": "新ê跟tuè者：",
  "notifications.column_settings.follow_request": "新ê跟tuè請求：",
  "notifications.column_settings.group": "群組",
  "notifications.column_settings.mention": "提起：",
  "notifications.column_settings.poll": "投票ê結果：",
  "notifications.column_settings.push": "Sak通知",
  "notifications.column_settings.quote": "引用：",
  "notifications.column_settings.reblog": "轉送：",
  "notifications.column_settings.show": "佇欄內底顯示",
  "notifications.column_settings.sound": "播放聲音",
  "notifications.column_settings.status": "新ê PO文：",
  "notifications.column_settings.unread_notifications.category": "Iáu bē讀ê通知",
  "notifications.column_settings.unread_notifications.highlight": "強調iáu bē讀ê通知",
  "notifications.column_settings.update": "編輯：",
  "notifications.filter.all": "Kui ê",
  "notifications.filter.boosts": "轉送",
  "notifications.filter.favourites": "收藏",
  "notifications.filter.follows": "跟tuè",
  "notifications.filter.mentions": "提起",
  "notifications.filter.polls": "投票結果",
  "notifications.filter.statuses": "Lí跟tuè ê lâng ê更新",
  "notifications.grant_permission": "賦予權限。",
  "notifications.group": "{count} 條通知",
  "notifications.mark_as_read": "Kā ta̍k條通知lóng標做有讀",
  "notifications.permission_denied": "因為khah早有拒絕瀏覽器權限ê請求，桌面通知bē當用。",
  "notifications.permission_denied_alert": "桌面通知bē當phah開來用，因為khah早瀏覽器ê權限受拒絕",
  "notifications.permission_required": "因為需要ê權限iáu無提供，桌面通知bē當用。",
  "notifications.policy.accept": "接受",
  "notifications.policy.accept_hint": "佇通知內底顯示",
  "notifications.policy.drop": "忽略",
  "notifications.policy.drop_hint": "送去虛空，bē koh看見",
  "notifications.policy.filter": "過濾器",
  "notifications.policy.filter_hint": "送kàu受過濾ê通知ê收件kheh-á",
  "notifications.policy.filter_limited_accounts_hint": "Hōo服侍器ê管理員限制",
  "notifications.policy.filter_limited_accounts_title": "受管制ê口座",
  "notifications.policy.filter_new_accounts.hint": "建立tī最近 {days, plural, other {# kang}}內",
  "notifications.policy.filter_new_accounts_title": "新ê口座",
  "notifications.policy.filter_not_followers_hint": "包含最近{days, plural, other {# kang}}內跟tuè lí ê lâng",
  "notifications.policy.filter_not_followers_title": "無跟tuè lí ê lâng",
  "notifications.policy.filter_not_following_hint": "直到lí手動允准in",
  "notifications.policy.filter_not_following_title": "Lí無跟tuè ê lâng",
  "notifications.policy.filter_private_mentions_hint": "通知ē受過濾，除非是tī lí ê提起ê回應內底，á是lí跟tuè送PO文ê lâng",
  "notifications.policy.filter_private_mentions_title": "家kī直接送來ê私人ê提起",
  "notifications.policy.title": "管理通知tuì……",
  "notifications_permission_banner.enable": "啟用桌面ê通知",
  "notifications_permission_banner.how_to_control": "Nā beh佇Mastodon關起來ê時陣收通知，請啟用桌面通知。若準啟用，Lí ē當通過面頂ê {icon} 鈕á，準準控制siánn物互動ê類型ē生桌面通知。",
  "notifications_permission_banner.title": "逐ê著看",
  "onboarding.follows.back": "轉去",
  "onboarding.follows.empty": "可惜，tsit-má無半條結果通顯示。Lí ē當試用tshiau-tshuē á是瀏覽探索ê頁，來tshuē beh跟tuè ê lâng，或者是sió等leh koh試。",
  "onboarding.follows.next": "後一步：設定lí ê個人資料",
  "onboarding.follows.search": "Tshiau-tshuē",
  "onboarding.follows.title": "請跟tuè lâng來開始。",
  "onboarding.profile.discoverable": "Hōo我ê個人資料通tshuē著",
  "onboarding.profile.discoverable_hint": "Nā lí揀beh佇Mastodon開hōo lâng發現ê功能，lí ê PO文通顯示佇tshiau-tshuē結果kap趨勢，而且你ê個人資料可能ē推薦hōo kap lí有相siâng興趣ê別lâng。",
  "onboarding.profile.display_name": "顯示ê名",
  "onboarding.profile.display_name_hint": "Lí ê全名á是別號……",
  "onboarding.profile.finish": "完成",
  "onboarding.profile.note": "個人紹介",
  "onboarding.profile.note_hint": "Lí ē當 @mention 別lâng á是用 #hashtag……",
  "onboarding.profile.title": "個人資料ê設定",
  "onboarding.profile.upload_avatar": "Kā個人資料ê相片傳起去。",
  "onboarding.profile.upload_header": "Kā個人資料ê橫條á ê圖傳起去",
  "password_confirmation.exceeds_maxlength": "密碼確認超過上大ê密碼長度",
  "password_confirmation.mismatching": "密碼確認kap密碼無合",
  "picture_in_picture.restore": "復原",
  "poll.closed": "關ah",
  "poll.refresh": "Koh更新",
  "poll.reveal": "看結果",
  "poll.total_people": "{count, plural, other {# ê人}}",
  "poll.total_votes": "{count, plural, other {# 張票}}",
  "poll.vote": "投票",
  "poll.voted": "Lí kā tse投票ah",
  "poll.votes": "{votes, plural, other {# 張票}}",
  "poll_button.add_poll": "加投票",
  "poll_button.remove_poll": "Thâi掉投票",
  "privacy.change": "改變PO文公開ê範圍",
  "privacy.direct.long": "逐位tsit篇PO文所提起ê",
  "privacy.direct.short": "私人ê提起",
  "privacy.private.long": "Kan-ta hōo跟tuè lí ê看",
  "privacy.private.short": "跟tuè伊ê",
  "privacy.public.long": "逐ê lâng（無論佇Mastodon以內á是以外）",
  "privacy.public.short": "公開ê",
  "privacy.quote.anyone": "{visibility}，允准PO文引用",
  "privacy.quote.disabled": "{visibility}，停止引用PO文",
  "privacy.quote.limited": "{visibility}，PO文引用受限",
  "privacy.unlisted.additional": "Tse ê行為kap公開相siâng，m̄-koh 就算lí佇口座設定phah開有關ê公開功能，PO文mā bē顯示佇即時ê動態、hashtag、探索kap Mastodon ê搜尋結果。",
  "privacy.unlisted.long": "Mài顯示tī Mastodon ê tshiau-tshuē結果、趨勢kap公共ê時間線。",
  "privacy.unlisted.short": "恬靜公開",
  "privacy_policy.last_updated": "上尾更新tī：{date}",
  "privacy_policy.title": "隱私權政策",
  "quote_error.edit": "佇編輯PO文ê時陣bē當加引文。",
  "quote_error.poll": "有投票ê PO文bē當引用。",
  "quote_error.private_mentions": "私訊bē當允准引用。",
  "quote_error.quote": "Tsi̍t改kan-ta ē當引用tsi̍t篇PO文。",
  "quote_error.unauthorized": "Lí bô權利引用tsit篇PO文。",
  "quote_error.upload": "有媒體附件ê PO文無允准引用。",
  "recommended": "推薦",
  "refresh": "Koh更新",
  "regeneration_indicator.please_stand_by": "請sió等leh。",
  "regeneration_indicator.preparing_your_home_feed": "Leh準備lí ê厝ê時間線……",
  "relative_time.days": "{number} kang進前",
  "relative_time.full.days": "{number, plural, other {# kang}}進前",
  "relative_time.full.hours": "{number, plural, other {# 點鐘}}進前",
  "relative_time.full.just_now": "頭tú-á",
  "relative_time.full.minutes": "{number, plural, other {# 分鐘}}進前",
  "relative_time.full.seconds": "{number, plural, other {# 秒}}進前",
  "relative_time.hours": "{number}點鐘前",
  "relative_time.just_now": "頭tú-á",
  "relative_time.minutes": "{number} 分進前",
  "relative_time.seconds": "{number} 秒進前",
  "relative_time.today": "今á日",
  "remove_quote_hint.button_label": "知ah",
  "remove_quote_hint.message": "Lí ē當tuì {icon} 選項ê目錄完成tsit ê動作",
  "remove_quote_hint.title": "Kám想beh thâi掉lí受引用ê PO文？",
  "reply_indicator.attachments": "{count, plural, other {# ê附件}}",
  "reply_indicator.cancel": "取消",
  "reply_indicator.poll": "投票",
  "report.block": "封鎖",
  "report.block_explanation": "Lí bē koh看著in ê PO文。In bē當看tio̍h lí ê PO文kap跟tuè lí。In ē發現家kī受著封鎖。",
  "report.categories.legal": "法律ê問題",
  "report.categories.other": "其他",
  "report.categories.spam": "Pùn-sò訊息",
  "report.categories.violation": "內容違反tsi̍t ê以上服侍器ê規則",
  "report.category.subtitle": "揀上合ê選項",
  "report.category.title": "Kā guán講tsit ê {type} 有siánn-mih代誌",
  "report.category.title_account": "個人資料",
  "report.category.title_status": "PO文",
  "report.close": "完成",
  "report.collection_comment": "Lí是án-tsuánn beh檢舉tsit ê收藏？",
  "report.comment.title": "Lí敢有別ê想beh hōo guán知ê？",
  "report.forward": "轉送kàu {target}",
  "report.forward_hint": "Tsit ê口座是別ê服侍器ê。Kám iā beh送bô落名ê檢舉ê khóo-pih？",
  "report.mute": "消音",
  "report.mute_explanation": "Lí bē koh看著in ê PO文。In iáu是ē當跟tuè lí，看lí ê PO文，而且m̄知in受消音。",
  "report.next": "繼續",
  "report.placeholder": "其他ê註釋",
  "report.reasons.dislike": "我無kah意",
  "report.reasons.dislike_description": "Tse是lí無愛看ê",
  "report.reasons.legal": "Tse無合法",
  "report.reasons.legal_description": "Lí相信伊違反lí ê國，á是服侍器所tiàm ê國ê法律",
  "report.reasons.other": "其他原因",
  "report.reasons.other_description": "Tsit ê問題bē當歸tī其他ê類別",
  "report.reasons.spam": "Tse是pùn-sò訊息",
  "report.reasons.spam_description": "Pháinn意ê連結、假互動，á是重複ê回應",
  "report.reasons.violation": "伊違反服侍器ê規定",
  "report.reasons.violation_description": "Lí明知伊違反特定ê規定",
  "report.rules.subtitle": "請揀所有符合ê選項",
  "report.rules.title": "違反siánn-mih規則？",
  "report.statuses.subtitle": "請揀所有符合ê選項",
  "report.statuses.title": "Kám有任何PO文證明tsit ê檢舉？",
  "report.submission_error": "檢舉bē當送",
  "report.submission_error_details": "請檢查lí ê網路連線，等leh koh試。",
  "report.submit": "送出",
  "report.target": "檢舉 {target}",
  "report.thanks.take_action": "下kha是你控制所beh 佇Mastodon看ê內容ê選項：",
  "report.thanks.take_action_actionable": "佇guán leh審核ê時陣，lí ē當tuì @{name} 做下kha ê行動：",
  "report.thanks.title": "無想beh看著tse？",
  "report.thanks.title_actionable": "多謝lí ê檢舉，guán ē處理。",
  "report.unfollow": "取消跟tuè @{name}",
  "report.unfollow_explanation": "Lí teh跟tuè tsit ê口座。Nā無beh佇頭頁ê時間線koh看見in ê PO文，請取消跟tuè。",
  "report_notification.attached_statuses": "附 {count, plural, one {{count} 篇PO文} other {{count} 篇PO文}}ah",
  "report_notification.categories.legal": "法規",
  "report_notification.categories.legal_sentence": "違法ê內容",
  "report_notification.categories.other": "其他",
  "report_notification.categories.other_sentence": "其他",
  "report_notification.categories.spam": "Pùn-sò訊息",
  "report_notification.categories.spam_sentence": "pùn-sò訊息",
  "report_notification.categories.violation": "違反規則",
  "report_notification.categories.violation_sentence": "違反規則",
  "report_notification.open": "Phah開檢舉",
  "search.clear": "清掉tshiau-tshuē",
  "search.no_recent_searches": "無最近ê tshiau-tshuē",
  "search.placeholder": "Tshiau-tshuē",
  "search.quick_action.account_search": "合 {x} ê個人檔案",
  "search.quick_action.go_to_account": "行去個人資料 {x}",
  "search.quick_action.go_to_hashtag": "行去hashtag {x}",
  "search.quick_action.open_url": "佇Mastodon來phah開URL",
  "search.quick_action.status_search": "合 {x} ê PO文",
  "search.search_or_paste": "Tshiau-tshuē á是貼URL",
  "search_popout.full_text_search_disabled_message": "{domain} 頂bē當用。",
  "search_popout.full_text_search_logged_out_message": "Kan-ta佇登入ê時通用。",
  "search_popout.language_code": "ISO語言代碼",
  "search_popout.options": "Tshiau-tshuē ê選項",
  "search_popout.quick_actions": "快速ê行動",
  "search_popout.recent": "最近ê tshiau-tshuē",
  "search_popout.specific_date": "特定ê日",
  "search_popout.user": "用者",
  "search_results.accounts": "個人資料",
  "search_results.all": "全部",
  "search_results.hashtags": "Hashtag",
  "search_results.no_results": "無結果。",
  "search_results.no_search_yet": "請試tshiau-tshuē PO文、個人資料á是hashtag。",
  "search_results.see_all": "看全部",
  "search_results.statuses": "PO文",
  "search_results.title": "Tshiau-tshuē「{q}」",
  "server_banner.about_active_users": "最近30kang用本站êlâng（月ê活動ê用者）",
  "server_banner.active_users": "活動ê用者",
  "server_banner.administered_by": "管理員：",
  "server_banner.is_one_of_many": "{domain} 屬佇tsē-tsē獨立ê Mastodonê服侍器，lí ē當用tse參與聯邦宇宙。",
  "server_banner.server_stats": "服侍器ê統計：",
  "sign_in_banner.create_account": "開口座",
  "sign_in_banner.follow_anyone": "跟tuè聯邦宇宙ê任何tsi̍t ê，用時間ê順序看所有ê內容。無演算法、廣告、點滑鼠ê餌(clickbait)。",
  "sign_in_banner.mastodon_is": "Mastodon是跟tuè siánn物當teh發生ê上贊ê方法。",
  "sign_in_banner.sign_in": "登入",
  "sign_in_banner.sso_redirect": "登入á是註冊",
  "skip_links.hotkey": "<span>組合khí</span> {hotkey}",
  "skip_links.skip_to_content": "跳kàu主內容",
  "skip_links.skip_to_navigation": "跳kàu主導覽",
  "status.admin_account": "Phah開 @{name} ê管理界面",
  "status.admin_domain": "Phah開 {domain} ê管理界面",
  "status.admin_status": "Tī管理界面內底看tsit篇PO文",
  "status.all_disabled": "轉送kap引用停止使用",
  "status.block": "封鎖 @{name}",
  "status.bookmark": "冊籤",
  "status.cancel_reblog_private": "取消轉送",
  "status.cannot_quote": "Lí bô允准引用tsit篇PO文。",
  "status.cannot_reblog": "Tsit篇PO文bē當轉送",
  "status.contains_quote": "包含引用",
  "status.context.loading": "載入其他回應",
  "status.context.loading_error": "Bē當載入新回應",
  "status.context.loading_success": "新ê回應載入ah",
  "status.context.more_replies_found": "Tshuē-tio̍h其他回應",
  "status.context.retry": "Koh試",
  "status.context.show": "顯示",
  "status.continued_thread": "接續ê討論線",
  "status.copy": "Khóo-pih PO文ê連結",
  "status.delete": "Thâi掉",
  "status.delete.success": "PO文thâi掉ah",
  "status.detailed_status": "對話ê詳細",
  "status.direct": "私人提起 @{name}",
  "status.direct_indicator": "私人ê提起",
  "status.edit": "編輯",
  "status.edited": "上尾編輯tī：{date}",
  "status.edited_x_times": "有編輯 {count, plural, one {{count} kái} other {{count} kái}}",
  "status.embed": "The̍h相tàu ê (embed)程式碼",
  "status.favourite": "收藏",
  "status.favourites_count": "{count, plural, one {{counter} 篇} other {{counter} 篇}}收藏",
  "status.filter": "過濾tsit 篇 PO文",
  "status.history.created": "{name} 佇 {date} 建立",
  "status.history.edited": "{name} 佇 {date} 編輯",
  "status.load_more": "載入其他ê內容",
  "status.media.open": "點來開",
  "status.media.show": "Tshi̍h來顯示",
  "status.media_hidden": "Khàm起來ê媒體",
  "status.mention": "提起 @{name}",
  "status.more": "詳細",
  "status.mute": "消音 @{name}",
  "status.mute_conversation": "Kā對話消音",
  "status.open": "Kā PO文展開",
  "status.quote": "引用",
  "status.quote.cancel": "取消引用",
  "status.quote_error.blocked_account_hint.title": "因為lí有封鎖 @{name}，tsit篇PO文受khàm掉。",
  "status.quote_error.blocked_domain_hint.title": "因為lí有封鎖 {domain}，tsit篇PO文受khàm掉。",
  "status.quote_error.filtered": "Lí所設定ê過濾器kā tse khàm起來",
  "status.quote_error.limited_account_hint.action": "Iáu是顯示",
  "status.quote_error.limited_account_hint.title": "Tsit ê口座予 {domain} ê管理員tshàng起來ah。",
  "status.quote_error.muted_account_hint.title": "因為lí有消音 @{name}，tsit篇PO文受khàm掉。",
  "status.quote_error.not_available": "PO文bē當看",
  "status.quote_error.pending_approval": "PO文當leh送",
  "status.quote_error.pending_approval_popout.body": "佇Mastodon，lí ē當控制PO文kám beh hōo lâng引用。Tsit篇PO文teh等原文作者允准。",
  "status.quote_error.revoked": "PO文已經hōo作者thâi掉",
  "status.quote_followers_only": "Kan-ta tuè我ê ē當引用PO文",
  "status.quote_manual_review": "作者ē hōo lâng人工審核",
  "status.quote_noun": "引用",
  "status.quote_policy_change": "改通引用ê lâng",
  "status.quote_post_author": "引用 @{name} ê PO文ah",
  "status.quote_private": "私人PO文bē當引用",
  "status.quotes.empty": "Iáu無lâng引用tsit篇PO文。Nā是有lâng引用，ē佇tsia顯示。.",
  "status.quotes.local_other_disclaimer": "Hōo作者拒絕引用ê引文bē當顯示。",
  "status.quotes.remote_other_disclaimer": "Kan-ta tuì {domain} 來ê引文tsiah保證佇tsia顯示。Hōo作者拒絕ê引文buē顯示。",
  "status.quotes_count": "{count, plural, one {{counter} 篇} other {{counter} 篇}}引用",
  "status.read_more": "讀詳細",
  "status.reblog": "轉送",
  "status.reblog_or_quote": "轉送á是引用",
  "status.reblog_private": "Koh再hām跟tuè ê分享",
  "status.reblogged_by": "{name} kā轉送ah",
  "status.reblogs.empty": "Iáu無lâng轉送tsit篇PO文。Nā是有lâng轉送，ē佇tsia顯示。",
  "status.reblogs_count": "{count, plural, one {{counter} 篇} other {{counter} 篇}}轉送",
  "status.redraft": "Thâi掉了後重寫",
  "status.remove_bookmark": "Thâi掉冊籤",
  "status.remove_favourite": "Tuì收藏內suá掉",
  "status.remove_quote": "Thâi掉",
  "status.replied_in_thread": "佇討論線內應",
  "status.replied_to": "回應 {name}",
  "status.reply": "回應",
  "status.replyAll": "應討論線",
  "status.report": "檢舉 @{name}",
  "status.request_quote": "要求引用PO文",
  "status.revoke_quote": "Kā 我ê PO文tuì @{name} ê thâi掉",
  "status.sensitive_warning": "敏感ê內容",
  "status.share": "分享",
  "status.show_less_all": "Lóng收起來",
  "status.show_more_all": "Lóng展開",
  "status.show_original": "顯示原文",
  "status.title.with_attachments": "{user} 有PO {attachmentCount, plural, other {{attachmentCount} ê附件}}",
  "status.translate": "翻譯",
  "status.translated_from_with": "用 {provider} 翻譯 {lang}",
  "status.uncached_media_warning": "Bē當先看māi",
  "status.unmute_conversation": "Kā對話取消消音",
  "subscribed_languages.lead": "Tī改變了後，kan-ta所揀ê語言ê PO文tsiah ē顯示佇lí ê厝ê時間線kap列單。揀「無」來接受所有語言êPO文。",
  "subscribed_languages.save": "儲存改變",
  "subscribed_languages.target": "改 {target} ê訂ê語言",
  "tabs_bar.home": "頭頁",
  "tabs_bar.menu": "目錄",
  "tabs_bar.notifications": "通知",
  "tabs_bar.publish": "新ê PO文",
  "tabs_bar.search": "Tshiau-tshuē",
  "tag.remove": "Suá掉",
  "terms_of_service.effective_as_of": "{date} 起實施",
  "terms_of_service.title": "服務規定",
  "terms_of_service.upcoming_changes_on": "Ē tī {date} 改變",
  "time_remaining.days": "Tshun {number, plural, other {# kang}}",
  "time_remaining.hours": "Tshun {number, plural, other {# 點鐘}}",
  "time_remaining.minutes": "Tshun {number, plural, other {# 分鐘}}",
  "time_remaining.moments": "Tshun ê時間",
  "time_remaining.seconds": "Tshun {number, plural, other {# 秒}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} ê} other {{counter} ê}} lâng tī過去 {days, plural, one {kang} other {{days} kang}}內底",
  "trends.trending_now": "Tsit-má ê趨勢",
  "ui.beforeunload": "Nā離開Mastodon，lí ê草稿ē無去。",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Giú放來傳起去",
  "upload_button.label": "加圖片、影片á是聲音檔",
  "upload_error.limit": "超過檔案傳起去ê限制",
  "upload_error.poll": "Bô允準佇投票ê時kā檔案傳起去。",
  "upload_error.quote": "引用PO文bē當kā檔案傳起去。",
  "upload_form.drag_and_drop.instructions": "Nā beh選媒體附件，請tshi̍h空白key á是Enter key。Giú ê時，請用方向key照指定ê方向suá媒體附件。Beh khǹg媒體附件佇伊ê新位置，請koh tshi̍h空白key á是Enter key，或者tshi̍h Esc key來取消。",
  "upload_form.drag_and_drop.on_drag_cancel": "Suá位取消ah，媒體附件 {item} khǹg落來ah。",
  "upload_form.drag_and_drop.on_drag_end": "媒體附件 {item} khǹg落來ah。",
  "upload_form.drag_and_drop.on_drag_over": "媒體附件 {item} suá tín動ah。",
  "upload_form.drag_and_drop.on_drag_start": "媒體附件 {item} 揀起來ah。",
  "upload_form.edit": "編輯",
  "upload_progress.label": "Teh傳起去……",
  "upload_progress.processing": "Teh處理……",
  "username.taken": "Tsit ê口座hōo lâng註冊ah，試別ê",
  "video.close": "關影片",
  "video.download": "Kā檔案載落去",
  "video.exit_fullscreen": "離開全螢幕",
  "video.expand": "展開影片",
  "video.fullscreen": "全螢幕",
  "video.hide": "Tshàng影片",
  "video.mute": "消音",
  "video.pause": "暫停",
  "video.play": "播出",
  "video.skip_backward": "跳kah後壁",
  "video.skip_forward": "跳kah頭前",
  "video.unmute": "取消消音",
  "video.volume_down": "變khah細聲",
  "video.volume_up": "變khah大聲",
  "visibility_modal.button_title": "設定通看ê程度",
  "visibility_modal.direct_quote_warning.text": "Nā是lí儲存目前ê設定，引用êPO文ē轉做連結。",
  "visibility_modal.direct_quote_warning.title": "引用bē當tàu入去私人ê提起",
  "visibility_modal.header": "通看ê程度kap互動",
  "visibility_modal.helper.direct_quoting": "Mastodon頂發布ê私人提起bē當hōo別lâng引用。",
  "visibility_modal.helper.privacy_editing": "Po文發布了後，bē當改通看ê程度。",
  "visibility_modal.helper.privacy_private_self_quote": "家kī引用ê私人PO文bē當改公開。",
  "visibility_modal.helper.private_quoting": "Mastodon頂發布ê kan-ta跟tuè ê通看ê PO文，bē當hōo別lâng引用。",
  "visibility_modal.helper.unlisted_quoting": "若別lâng引用lí，in ê PO文mā ē tuì趨勢時間線隱藏。",
  "visibility_modal.instructions": "控制ē當hām tsit篇PO文互動ê lâng。Lí mā ē當用 <link>偏愛ê設定 > PO文預設<link>，kā設定作用kàu ta̍k篇未來ê PO文。",
  "visibility_modal.privacy_label": "通看見ê程度",
  "visibility_modal.quote_followers": "Kan-ta hōo跟tuè ê lâng",
  "visibility_modal.quote_label": "Ē當引用ê lâng",
  "visibility_modal.quote_nobody": "Kan-ta我",
  "visibility_modal.quote_public": "Ta̍k ê lâng",
  "visibility_modal.save": "儲存"
}
